/* eslint-disable */
import { DateOnly } from 'src/utils/dates';
import { DateTime } from 'src/utils/dates';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: DateOnly;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: DateTime;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**  Creates an asset upload url with the following  key structure `assets/${UUID}`.  */
  createAssetUploadUrl: CreateAssetUploadUrlResult;
  importBaseConfigurations: ImportBaseConfigurationResult;
  importConfigurations: ImportConfigurationResult;
  importBaseConfigurationOptions: BaseConfigurationOptionResult;
  createCustomer: EmptyResult;
  saveCustomerConfiguration: SaveCustomerConfigurationResult;
  duplicateCustomerConfiguration: SaveCustomerConfigurationResult;
  importCutOffs: ImportCutOffsResult;
  importDevelopments: ImportDevelopmentsResult;
  importElevations: ImportElevationsResult;
  importGSheetOptionPricing: Array<GSheetOptionPricing>;
  saveHelloWorld: SaveHelloWorldResult;
  saveHomeowner: SaveHomeownerResult;
  saveInternalUser: SaveInternalUserResult;
  addJob: EmptyResult;
  importMarkets: ImportMarketsResult;
  refreshMarketPrices: Array<Market>;
  importOptions: ImportOptionsResult;
  importPlans: ImportPlansResult;
  importAll: EmptyResult;
  importPlanOptionConflicts: ImportPlanOptionConflictsResult;
  importProperties?: Maybe<ImportPropertiesResult>;
  importPropertyCutOffs: ImportPropertyCutOffsResult;
  importPropertyImages: EmptyResult;
  importSpecLevels: ImportSpecLevelResult;
  saveUser: SaveUserResult;
  activateUser: ActivateUserResult;
  deactivateUser: DeactivateUserResult;
};


export type MutationCreateAssetUploadUrlArgs = {
  input: CreateAssetUploadUrlInput;
};


export type MutationCreateCustomerArgs = {
  input: SaveCustomerInput;
};


export type MutationSaveCustomerConfigurationArgs = {
  input: SaveCustomerConfigurationInput;
};


export type MutationDuplicateCustomerConfigurationArgs = {
  input: DuplicateCustomerConfigurationInput;
};


export type MutationSaveHelloWorldArgs = {
  input: SaveHelloWorldInput;
};


export type MutationSaveHomeownerArgs = {
  input: SaveHomeownerInput;
};


export type MutationSaveInternalUserArgs = {
  input: SaveInternalUserInput;
};


export type MutationAddJobArgs = {
  input: AddJobInput;
};


export type MutationImportPropertiesArgs = {
  softDelete?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSaveUserArgs = {
  input: SaveUserInput;
};


export type MutationActivateUserArgs = {
  input: ActivateUserInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};

export type Asset = {
  __typename?: 'Asset';
  id: Scalars['ID'];
  contentType: Scalars['String'];
  /**
   *   After the asset is uploaded, it can be downloaded from this URL.
   *
   * This is an S3 signed url, which means the user has already been authed when
   * creating the returned URL, and so can directly access this URL without any extra auth.
   * However, that also means this URL is unique per request (it has timestamps in it)
   * and so won't be cached.
   *
   * It expires after 1 week.
   */
  downloadUrl: Scalars['String'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String'];
  /**
   *   Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']>;
  /**
   *   Similar to downloadUrl, but is a consistent path like `/asset?id=assetId` so
   * that caching works.
   *
   * Note that auth will be done on access to `/asset` and so currently this only
   * works for internal users.
   */
  url: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  sizeInBytes?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['String'];
};


export type AssetPreviewUrlArgs = {
  resizing: AssetResizing;
};

export type CreateAssetUploadUrlInput = {
  contentType: Scalars['String'];
  previewResizing?: InputMaybe<AssetResizing>;
};

export type CreateAssetUploadUrlResult = {
  __typename?: 'CreateAssetUploadUrlResult';
  s3Key: Scalars['String'];
  uploadUrl: Scalars['String'];
  /** After the asset is uploaded, it can be viewed at this URL. */
  downloadUrl: Scalars['String'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String'];
  /**
   *   Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Only generated if previewResizing is provided as mutation input
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']>;
};

export type AssetResizing = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<AssetResizingRegion>;
  /** Optional output image format, e.g. "jpg", "png", defaults to original asset format. */
  format?: InputMaybe<AssetResizingFormat>;
};

export enum AssetResizingFormat {
  Jpg = 'jpg',
  Png = 'png'
}

export enum AssetResizingRegion {
  Square = 'SQUARE',
  Full = 'FULL',
  Auto = 'AUTO'
}

export type AssetInput = {
  id?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  /** This field is only accepted for Asset creation */
  contentType?: InputMaybe<Scalars['String']>;
  /** This field is accepted for Asset creation and update */
  fileName?: InputMaybe<Scalars['String']>;
  /** This field is only accepted for Asset creation */
  s3Key?: InputMaybe<Scalars['String']>;
  /** This field is only accepted for Asset creation */
  sizeInBytes?: InputMaybe<Scalars['Int']>;
};

export type BaseConfiguration = {
  __typename?: 'BaseConfiguration';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  plan: Plan;
  options: Array<ConfigurationOption>;
};

export type ImportBaseConfigurationResult = {
  __typename?: 'ImportBaseConfigurationResult';
  baseConfigurations: Array<BaseConfiguration>;
};

export type Configuration = {
  __typename?: 'Configuration';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevation: Elevation;
  property: Property;
  specLevel: SpecLevel;
  plan: Plan;
};

export type ImportConfigurationResult = {
  __typename?: 'ImportConfigurationResult';
  configurations: Array<Configuration>;
};

export type ConfigurationOption = {
  __typename?: 'ConfigurationOption';
  id: Scalars['ID'];
  priceInCents: Scalars['Int'];
  baseConfiguration?: Maybe<BaseConfiguration>;
  customerConfiguration?: Maybe<CustomerConfiguration>;
  option: Option;
};

export type BaseConfigurationOptionResult = {
  __typename?: 'BaseConfigurationOptionResult';
  configurationOptions: Array<ConfigurationOption>;
};

export type Customer = {
  __typename?: 'Customer';
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
};

export type SaveCustomerInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  utmSource?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['String']>;
};

export type ImportCustomersResult = {
  __typename?: 'ImportCustomersResult';
  customers: Array<Customer>;
};

export type Query = {
  __typename?: 'Query';
  customerConfiguration: CustomerConfiguration;
  cutOffs: Array<CutOff>;
  developments: Array<Development>;
  markets: Array<Market>;
  market: Market;
  properties: Array<Property>;
  propertyByBlueprintId: Property;
  testQuery: Scalars['Int'];
  /**  fuzzy search for properties matching address  */
  uwProperties: Array<UwProperty>;
  /**  property details  */
  uwProperty?: Maybe<UwProperty>;
};


export type QueryCustomerConfigurationArgs = {
  filter: CustomerConfigurationFilter;
};


export type QueryMarketArgs = {
  filter: MarketFilter;
};


export type QueryPropertiesArgs = {
  filter?: InputMaybe<PropertyFilter>;
};


export type QueryPropertyByBlueprintIdArgs = {
  id: Scalars['ID'];
};


export type QueryTestQueryArgs = {
  error?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUwPropertiesArgs = {
  address: Scalars['String'];
};


export type QueryUwPropertyArgs = {
  dpid: Scalars['ID'];
};

export type DuplicateCustomerConfigurationInput = {
  code: Scalars['String'];
};

export type CustomerConfiguration = {
  __typename?: 'CustomerConfiguration';
  id: Scalars['ID'];
  code: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  reservedAt?: Maybe<Scalars['DateTime']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  customer?: Maybe<Customer>;
  plan: Plan;
  isReversed: Scalars['Boolean'];
  options: Array<ConfigurationOption>;
  planPriceInCents: Scalars['Int'];
  status: CustomerConfigurationStatus;
  originalCustomerConfiguration?: Maybe<CustomerConfiguration>;
};

export type SaveCustomerConfigurationInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  reservedAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<SaveCustomerConfigurationCustomerInput>;
  planId?: InputMaybe<Scalars['ID']>;
  configurationOptions?: InputMaybe<Array<ConfigurationOptionInput>>;
  isReversed?: InputMaybe<Scalars['Boolean']>;
};

export type ConfigurationOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  option?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
};

export type SaveCustomerConfigurationCustomerInput = {
  id?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type SaveCustomerConfigurationResult = {
  __typename?: 'SaveCustomerConfigurationResult';
  customerConfiguration: CustomerConfiguration;
};

export type CustomerConfigurationFilter = {
  id?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
};

export enum CustomerConfigurationStatus {
  Draft = 'DRAFT',
  Reserved = 'RESERVED',
  Expired = 'EXPIRED'
}

export type CutOff = {
  __typename?: 'CutOff';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  marketingName: Scalars['String'];
  marketingHexColor: Scalars['String'];
  sortOrder?: Maybe<Scalars['Int']>;
};

export type ImportCutOffsResult = {
  __typename?: 'ImportCutOffsResult';
  cutOffs: Array<CutOff>;
};

export type Development = {
  __typename?: 'Development';
  id: Scalars['ID'];
  airtableId: Scalars['ID'];
  name: Scalars['String'];
  market: Market;
  properties: Array<Property>;
  plans: Array<Plan>;
};

export type ImportDevelopmentsResult = {
  __typename?: 'ImportDevelopmentsResult';
  developments: Array<Development>;
};

export type Elevation = {
  __typename?: 'Elevation';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  blueprintOptionCode: Scalars['String'];
  blueprintOptionId: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  configurations: Array<Configuration>;
};

export type ImportElevationsResult = {
  __typename?: 'ImportElevationsResult';
  elevations: Array<Elevation>;
};

export enum LotType {
  Boyl = 'BOYL',
  Bool = 'BOOL'
}

export type LotTypeDetail = {
  __typename?: 'LotTypeDetail';
  code: LotType;
  name: Scalars['String'];
};

export enum OptionImageType {
  Swatch = 'SWATCH',
  Display = 'DISPLAY',
  Moodboard = 'MOODBOARD'
}

export type OptionImageTypeDetail = {
  __typename?: 'OptionImageTypeDetail';
  code: OptionImageType;
  name: Scalars['String'];
};

export enum OptionType {
  SingleSelect = 'SINGLE_SELECT',
  MultiSelect = 'MULTI_SELECT'
}

export type OptionTypeDetail = {
  __typename?: 'OptionTypeDetail';
  code: OptionType;
  name: Scalars['String'];
};

export enum PropertyImageType {
  Exterior = 'EXTERIOR',
  Interior = 'INTERIOR'
}

export type PropertyImageTypeDetail = {
  __typename?: 'PropertyImageTypeDetail';
  code: PropertyImageType;
  name: Scalars['String'];
};

export enum UserType {
  Anonymous = 'ANONYMOUS',
  System = 'SYSTEM',
  Internal = 'INTERNAL',
  Homeowner = 'HOMEOWNER'
}

export type UserTypeDetail = {
  __typename?: 'UserTypeDetail';
  code: UserType;
  name: Scalars['String'];
};

export type GSheetOptionPricing = {
  __typename?: 'GSheetOptionPricing';
  id: Scalars['ID'];
  price: Scalars['Int'];
};

export type HelloWorld = {
  __typename?: 'HelloWorld';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  isActive?: Maybe<Scalars['Boolean']>;
};

export type SaveHelloWorldInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type SaveHelloWorldResult = {
  __typename?: 'SaveHelloWorldResult';
  helloWorld: HelloWorld;
};

export type Homeowner = {
  __typename?: 'Homeowner';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
  lastActive?: Maybe<Scalars['DateTime']>;
};

export type SaveHomeownerInput = {
  id?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  lastActive?: InputMaybe<Scalars['DateTime']>;
};

export type SaveHomeownerResult = {
  __typename?: 'SaveHomeownerResult';
  homeowner: Homeowner;
};

export type InternalUser = {
  __typename?: 'InternalUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  avatarUrl: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type SaveInternalUserInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type SaveInternalUserResult = {
  __typename?: 'SaveInternalUserResult';
  internalUser: InternalUser;
};

export type AddJobInput = {
  name: Scalars['String'];
  args?: InputMaybe<Scalars['JSONObject']>;
};

export type Market = {
  __typename?: 'Market';
  id: Scalars['ID'];
  airtableId: Scalars['ID'];
  blueprintMarketId: Scalars['String'];
  name: Scalars['String'];
  imageUrl: Scalars['String'];
  developments: Array<Development>;
  propertyPriceMinInCents?: Maybe<Scalars['Int']>;
};

export type ImportMarketsResult = {
  __typename?: 'ImportMarketsResult';
  markets: Array<Market>;
};

export type MarketFilter = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Option = {
  __typename?: 'Option';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Int'];
  optionCode: Scalars['String'];
  sortOrder?: Maybe<Scalars['Int']>;
  bedrooms: Scalars['Int'];
  fullBathrooms: Scalars['Int'];
  halfBathrooms: Scalars['Int'];
  garageAttached: Scalars['Int'];
  garagePort: Scalars['Int'];
  garageDetached: Scalars['Int'];
  sqft: Scalars['Int'];
  parentOption?: Maybe<Option>;
  /** TODO: Should we rename this to `childOptions`? */
  options: Array<Option>;
  images: Array<OptionImage>;
  planOptionType: PlanOptionType;
  included: Scalars['Boolean'];
};

export type ImportOptionsResult = {
  __typename?: 'ImportOptionsResult';
  options: Array<Option>;
};

export type OptionImage = {
  __typename?: 'OptionImage';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  option: Option;
  type: OptionImageTypeDetail;
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['ID'];
  airtableId: Scalars['ID'];
  name: Scalars['String'];
  blueprintLegacyReadyPlanCode: Scalars['String'];
  blueprintReadyPlanCode: Scalars['String'];
  blueprintReadyPlanId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  development: Development;
  features: Array<PlanFeature>;
  locations: Array<PlanLocation>;
  elevations: Array<Elevation>;
  specLevels: Array<SpecLevel>;
  customerConfigurations: Array<CustomerConfiguration>;
  baseConfiguration?: Maybe<BaseConfiguration>;
  optionConflicts: Array<PlanOptionConflict>;
  minBedrooms: Scalars['Int'];
  maxBedrooms: Scalars['Int'];
  minFullBathrooms: Scalars['Int'];
  maxFullBathrooms: Scalars['Int'];
  minHalfBathrooms: Scalars['Int'];
  maxHalfBathrooms: Scalars['Int'];
  minGarageAttached: Scalars['Int'];
  maxGarageAttached: Scalars['Int'];
  minGaragePort: Scalars['Int'];
  maxGaragePort: Scalars['Int'];
  minGarageDetached: Scalars['Int'];
  maxGarageDetached: Scalars['Int'];
  minSqft: Scalars['Int'];
  maxSqft: Scalars['Int'];
  priceInCents: Scalars['Int'];
  floorPlans: Array<PlanFloorPlan>;
  optionTypes: Array<PlanOptionType>;
  expirationDays: Scalars['Int'];
  tourUrl?: Maybe<Scalars['String']>;
};


export type PlanOptionTypesArgs = {
  filter?: InputMaybe<PlanOptionTypesFilter>;
};

export type PlanOptionTypesFilter = {
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type ImportPlansResult = {
  __typename?: 'ImportPlansResult';
  plans: Array<Plan>;
};

export type PlanFeature = {
  __typename?: 'PlanFeature';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  iconName: Scalars['String'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  plan: Plan;
};

export type PlanFloorPlan = {
  __typename?: 'PlanFloorPlan';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  imageUrl: Scalars['String'];
};

export type PlanLocation = {
  __typename?: 'PlanLocation';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  imageUrl: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  plan: Plan;
};

export type PlanOptionConflict = {
  __typename?: 'PlanOptionConflict';
  id: Scalars['ID'];
  optionCode: Scalars['String'];
  conflictOptionCode: Scalars['String'];
  reason: Scalars['String'];
  plan: Plan;
};

export type ImportPlanOptionConflictsResult = {
  __typename?: 'ImportPlanOptionConflictsResult';
  planOptionConflicts: Array<PlanOptionConflict>;
};

export type PlanOptionType = {
  __typename?: 'PlanOptionType';
  id: Scalars['ID'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
  type: OptionTypeDetail;
  options: Array<Option>;
};

export type Property = {
  __typename?: 'Property';
  id: Scalars['ID'];
  /** External IDs */
  airtableId: Scalars['String'];
  blueprintProjectId: Scalars['String'];
  /** Relationships */
  development: Development;
  customers: Array<Customer>;
  /** Address */
  streetAddress: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  priceInCents: Scalars['Int'];
  /** Program Data */
  bedrooms: Scalars['String'];
  bathrooms: Scalars['String'];
  sqft: Scalars['Int'];
  /** Personalization URL */
  url?: Maybe<Scalars['String']>;
  /**
   *   These fields help the UI show tags and descriptions related to when the
   * property will be delivered and if personalization is still available.
   */
  expectedDeliveryDate?: Maybe<Scalars['Date']>;
  tourUrl?: Maybe<Scalars['String']>;
  floorPlans: Array<PropertyFloorPlan>;
  configurations: Array<Configuration>;
  garageAttached: Scalars['Int'];
  garagePort: Scalars['Int'];
  baseConfiguration?: Maybe<Configuration>;
  canDisplay?: Maybe<PotentialOperation>;
  /**
   *   When only exterior property images exist then exterior and plan location images returned.
   * When exterior and interior property images exist then the following order is returned:
   * property exterior images, property interior images associated to a plan location, property interior
   * images not associated to a plan location, any plan location interior images
   */
  imageGallery: Array<ImageGalleryImage>;
  mostRecentCutOff?: Maybe<PropertyCutOff>;
  isCustomizable: Scalars['Boolean'];
};


export type PropertyImageGalleryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type ImportPropertiesResult = {
  __typename?: 'ImportPropertiesResult';
  properties: Array<Property>;
};

export type PropertyFilter = {
  market?: InputMaybe<Array<Scalars['ID']>>;
  maxPriceInCents?: InputMaybe<Scalars['Int']>;
  maxSqft?: InputMaybe<Scalars['Int']>;
  minBathrooms?: InputMaybe<Scalars['Int']>;
  minBedrooms?: InputMaybe<Scalars['Int']>;
  minPriceInCents?: InputMaybe<Scalars['Int']>;
  minSqft?: InputMaybe<Scalars['Int']>;
  canDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type ImageGalleryImage = {
  __typename?: 'ImageGalleryImage';
  id: Scalars['ID'];
  type: PropertyImageType;
  imageUrl: Scalars['String'];
  planLocation?: Maybe<PlanLocation>;
};

export type PropertyCutOff = {
  __typename?: 'PropertyCutOff';
  id: Scalars['ID'];
  /** Protected field. */
  airtableId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  cutOff: CutOff;
};

export type ImportPropertyCutOffsResult = {
  __typename?: 'ImportPropertyCutOffsResult';
  propertyCutOffs: Array<PropertyCutOff>;
};

export type PropertyFloorPlan = {
  __typename?: 'PropertyFloorPlan';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  imageUrl: Scalars['String'];
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum DateOperation {
  Before = 'BEFORE',
  On = 'ON',
  After = 'AFTER',
  Between = 'BETWEEN'
}

/**
 * Represents both whether an operation is performable, and if not the reasons.
 * When the reason relates to a specific entity, we return it for convenient UI navigation.
 */
export type PotentialOperation = {
  __typename?: 'PotentialOperation';
  allowed: Scalars['Boolean'];
  disabledReasons: Array<Reason>;
};

export type Reason = {
  __typename?: 'Reason';
  message: Scalars['String'];
};

export type UserError = {
  __typename?: 'UserError';
  message: Scalars['String'];
};

/** A standard result for when we're not returning any user errors, and instead will just fail the request */
export type EmptyResult = {
  __typename?: 'EmptyResult';
  emptyResult?: Maybe<Scalars['String']>;
};

/** Generic bulk delete input type */
export type DeleteEntitiesInput = {
  id: Array<Scalars['ID']>;
};

/** Generic delete input type */
export type DeleteEntityInput = {
  id: Scalars['ID'];
};

/**
 * Pagination info.
 *
 * Eventually this would have `lastCursor` and `totalCount` but we don't currently need that.
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
};

export type History = {
  __typename?: 'History';
  recordedAt: Scalars['DateTime'];
  avatar: Scalars['String'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
};

export type SpecLevel = {
  __typename?: 'SpecLevel';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  blueprintSpecLevelId: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  plan: Plan;
  configurations: Array<Configuration>;
};

export type ImportSpecLevelResult = {
  __typename?: 'ImportSpecLevelResult';
  specLevels: Array<SpecLevel>;
};

export type User = {
  __typename?: 'User';
  /** Note ID is not required because a system user would not have it. */
  id?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  gsuiteEmailAlias?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: UserTypeDetail;
  homeowner?: Maybe<Homeowner>;
  internalUser?: Maybe<InternalUser>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type SaveUserInput = {
  id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']>;
  gsuiteEmailAlias?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserType>;
  internalUserId?: InputMaybe<Scalars['ID']>;
};

export type SaveUserResult = {
  __typename?: 'SaveUserResult';
  userErrors: Array<UserError>;
};

export type DeactivateUserInput = {
  email: Scalars['String'];
};

export type DeactivateUserResult = {
  __typename?: 'DeactivateUserResult';
  userErrors: Array<UserError>;
};

export type ActivateUserInput = {
  email: Scalars['String'];
};

export type ActivateUserResult = {
  __typename?: 'ActivateUserResult';
  userErrors: Array<UserError>;
};

export type UwProperty = {
  __typename?: 'UwProperty';
  dpid: Scalars['ID'];
  fullStreetAddress: Scalars['String'];
  cityName: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  unitNumber?: Maybe<Scalars['String']>;
  propertyTypeSimple?: Maybe<Scalars['String']>;
  lotSize?: Maybe<Scalars['Int']>;
  yearBuiltOrRenovated?: Maybe<Scalars['String']>;
  finishedSqft?: Maybe<Scalars['Int']>;
  totalSqft?: Maybe<Scalars['Int']>;
  numBedrooms?: Maybe<Scalars['Float']>;
  numBaths?: Maybe<Scalars['Float']>;
  numStories?: Maybe<Scalars['Float']>;
  hasPool?: Maybe<Scalars['Boolean']>;
  garageNumCars?: Maybe<Scalars['Int']>;
  buildableSqft?: Maybe<Scalars['Float']>;
  lotFrontageFeet?: Maybe<Scalars['Int']>;
  lotDepthFeet?: Maybe<Scalars['Int']>;
  zoning?: Maybe<Scalars['String']>;
};

export type ContractedCustomerConfigurationByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ContractedCustomerConfigurationByCodeQuery = { __typename?: 'Query', customerConfiguration: { __typename?: 'CustomerConfiguration', id: string, code: string, planPriceInCents: number, expiredAt?: DateTime | null | undefined, reservedAt?: DateTime | null | undefined, isReversed: boolean, plan: { __typename?: 'Plan', tourUrl?: string | null | undefined, id: string, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, name: string, expirationDays: number, baseConfiguration?: { __typename?: 'BaseConfiguration', id: string, options: Array<{ __typename?: 'ConfigurationOption', id: string, option: { __typename?: 'Option', id: string } }> } | null | undefined, optionConflicts: Array<{ __typename?: 'PlanOptionConflict', id: string, optionCode: string, conflictOptionCode: string, reason: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> }, options: Array<{ __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } }> } };

export type ContractedCustomerConfigurationFragment = { __typename?: 'CustomerConfiguration', id: string, code: string, planPriceInCents: number, expiredAt?: DateTime | null | undefined, reservedAt?: DateTime | null | undefined, isReversed: boolean, plan: { __typename?: 'Plan', tourUrl?: string | null | undefined, id: string, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, name: string, expirationDays: number, baseConfiguration?: { __typename?: 'BaseConfiguration', id: string, options: Array<{ __typename?: 'ConfigurationOption', id: string, option: { __typename?: 'Option', id: string } }> } | null | undefined, optionConflicts: Array<{ __typename?: 'PlanOptionConflict', id: string, optionCode: string, conflictOptionCode: string, reason: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> }, options: Array<{ __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } }> };

export type CreateCustomerMutationVariables = Exact<{
  input: SaveCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type CustomerConfigurationByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type CustomerConfigurationByCodeQuery = { __typename?: 'Query', customerConfiguration: { __typename?: 'CustomerConfiguration', id: string, name?: string | null | undefined, code: string, planPriceInCents: number, expiredAt?: DateTime | null | undefined, reservedAt?: DateTime | null | undefined, status: CustomerConfigurationStatus, isReversed: boolean, customer?: { __typename?: 'Customer', id: string, email: string } | null | undefined, plan: { __typename?: 'Plan', id: string, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, name: string, expirationDays: number, baseConfiguration?: { __typename?: 'BaseConfiguration', id: string, options: Array<{ __typename?: 'ConfigurationOption', id: string, option: { __typename?: 'Option', id: string } }> } | null | undefined, optionConflicts: Array<{ __typename?: 'PlanOptionConflict', id: string, optionCode: string, conflictOptionCode: string, reason: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> }, options: Array<{ __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } }> } };

export type SaveCustomerConfigurationMutationVariables = Exact<{
  input: SaveCustomerConfigurationInput;
}>;


export type SaveCustomerConfigurationMutation = { __typename?: 'Mutation', saveCustomerConfiguration: { __typename?: 'SaveCustomerConfigurationResult', customerConfiguration: { __typename?: 'CustomerConfiguration', id: string, name?: string | null | undefined, code: string, planPriceInCents: number, expiredAt?: DateTime | null | undefined, reservedAt?: DateTime | null | undefined, status: CustomerConfigurationStatus, isReversed: boolean, customer?: { __typename?: 'Customer', id: string, email: string } | null | undefined, plan: { __typename?: 'Plan', id: string, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, name: string, expirationDays: number, baseConfiguration?: { __typename?: 'BaseConfiguration', id: string, options: Array<{ __typename?: 'ConfigurationOption', id: string, option: { __typename?: 'Option', id: string } }> } | null | undefined, optionConflicts: Array<{ __typename?: 'PlanOptionConflict', id: string, optionCode: string, conflictOptionCode: string, reason: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> }, options: Array<{ __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } }> } } };

export type SaveNewCustomerConfigurationMutationVariables = Exact<{
  input: SaveCustomerConfigurationInput;
}>;


export type SaveNewCustomerConfigurationMutation = { __typename?: 'Mutation', saveCustomerConfiguration: { __typename?: 'SaveCustomerConfigurationResult', customerConfiguration: { __typename?: 'CustomerConfiguration', id: string, code: string } } };

export type DuplicateCustomerConfigurationMutationVariables = Exact<{
  input: DuplicateCustomerConfigurationInput;
}>;


export type DuplicateCustomerConfigurationMutation = { __typename?: 'Mutation', duplicateCustomerConfiguration: { __typename?: 'SaveCustomerConfigurationResult', customerConfiguration: { __typename?: 'CustomerConfiguration', id: string, code: string } } };

export type ToggleOptionMutationVariables = Exact<{
  input: SaveCustomerConfigurationInput;
}>;


export type ToggleOptionMutation = { __typename?: 'Mutation', saveCustomerConfiguration: { __typename?: 'SaveCustomerConfigurationResult', customerConfiguration: { __typename?: 'CustomerConfiguration', id: string, options: Array<{ __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } }> } } };

export type ConfiguratorConfigurationFragment = { __typename?: 'CustomerConfiguration', id: string, name?: string | null | undefined, code: string, planPriceInCents: number, expiredAt?: DateTime | null | undefined, reservedAt?: DateTime | null | undefined, status: CustomerConfigurationStatus, isReversed: boolean, customer?: { __typename?: 'Customer', id: string, email: string } | null | undefined, plan: { __typename?: 'Plan', id: string, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, name: string, expirationDays: number, baseConfiguration?: { __typename?: 'BaseConfiguration', id: string, options: Array<{ __typename?: 'ConfigurationOption', id: string, option: { __typename?: 'Option', id: string } }> } | null | undefined, optionConflicts: Array<{ __typename?: 'PlanOptionConflict', id: string, optionCode: string, conflictOptionCode: string, reason: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> }, options: Array<{ __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } }> };

export type ConfigurationCustomerFragment = { __typename?: 'Customer', id: string, email: string };

export type ConfiguratorConfigurationPlanFragment = { __typename?: 'Plan', id: string, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, name: string, expirationDays: number, baseConfiguration?: { __typename?: 'BaseConfiguration', id: string, options: Array<{ __typename?: 'ConfigurationOption', id: string, option: { __typename?: 'Option', id: string } }> } | null | undefined, optionConflicts: Array<{ __typename?: 'PlanOptionConflict', id: string, optionCode: string, conflictOptionCode: string, reason: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> };

export type ConfiguratorOptionConflictFragment = { __typename?: 'PlanOptionConflict', id: string, optionCode: string, conflictOptionCode: string, reason: string };

export type ConfiguratorPlanOptionTypeFragment = { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } }> };

export type ConfiguratorConfigurationOptionFragment = { __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } };

export type ConfiguratorOptionFragment = { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } };

export type ConfiguratorOptionImageFragment = { __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } };

export type ConfiguratorFloorPlanFragment = { __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string };

export type InternalConfiguratorMarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalConfiguratorMarketsQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, blueprintMarketId: string, name: string, imageUrl: string }> };

export type ConfiguratorMarketFragment = { __typename?: 'Market', id: string, blueprintMarketId: string, name: string, imageUrl: string };

export type InventoryFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryFiltersQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, blueprintMarketId: string, name: string }>, cutOffs: Array<{ __typename?: 'CutOff', id: string, description?: string | null | undefined, marketingName: string, marketingHexColor: string }> };

export type InventoryMarketFragment = { __typename?: 'Market', id: string, blueprintMarketId: string, name: string };

export type InventoryPropertiesQueryVariables = Exact<{
  filter: PropertyFilter;
}>;


export type InventoryPropertiesQuery = { __typename?: 'Query', properties: Array<{ __typename?: 'Property', id: string, streetAddress: string, city: string, state: string, postalCode: string, bathrooms: string, bedrooms: string, latitude: string, longitude: string, priceInCents: number, sqft: number, blueprintProjectId: string, url?: string | null | undefined, isCustomizable: boolean, imageGallery: Array<{ __typename?: 'ImageGalleryImage', id: string, imageUrl: string, planLocation?: { __typename?: 'PlanLocation', id: string, name: string } | null | undefined }>, mostRecentCutOff?: { __typename?: 'PropertyCutOff', id: string, cutOff: { __typename?: 'CutOff', id: string, description?: string | null | undefined, marketingName: string, marketingHexColor: string } } | null | undefined }> };

export type CutOffFragment = { __typename?: 'CutOff', id: string, description?: string | null | undefined, marketingName: string, marketingHexColor: string };

export type InventoryPropertyFragment = { __typename?: 'Property', id: string, streetAddress: string, city: string, state: string, postalCode: string, bathrooms: string, bedrooms: string, latitude: string, longitude: string, priceInCents: number, sqft: number, blueprintProjectId: string, url?: string | null | undefined, isCustomizable: boolean, imageGallery: Array<{ __typename?: 'ImageGalleryImage', id: string, imageUrl: string, planLocation?: { __typename?: 'PlanLocation', id: string, name: string } | null | undefined }>, mostRecentCutOff?: { __typename?: 'PropertyCutOff', id: string, cutOff: { __typename?: 'CutOff', id: string, description?: string | null | undefined, marketingName: string, marketingHexColor: string } } | null | undefined };

export type SummaryPrintConfigurationQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SummaryPrintConfigurationQuery = { __typename?: 'Query', customerConfiguration: { __typename?: 'CustomerConfiguration', id: string, name?: string | null | undefined, code: string, planPriceInCents: number, expiredAt?: DateTime | null | undefined, reservedAt?: DateTime | null | undefined, status: CustomerConfigurationStatus, isReversed: boolean, customer?: { __typename?: 'Customer', id: string, email: string } | null | undefined, plan: { __typename?: 'Plan', id: string, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, name: string, expirationDays: number, baseConfiguration?: { __typename?: 'BaseConfiguration', id: string, options: Array<{ __typename?: 'ConfigurationOption', id: string, option: { __typename?: 'Option', id: string } }> } | null | undefined, optionConflicts: Array<{ __typename?: 'PlanOptionConflict', id: string, optionCode: string, conflictOptionCode: string, reason: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> }, options: Array<{ __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, included: boolean, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } }> } };

export type SummaryPrintConfigurationFragment = { __typename?: 'CustomerConfiguration', id: string, name?: string | null | undefined, code: string, planPriceInCents: number, expiredAt?: DateTime | null | undefined, reservedAt?: DateTime | null | undefined, status: CustomerConfigurationStatus, isReversed: boolean, customer?: { __typename?: 'Customer', id: string, email: string } | null | undefined, plan: { __typename?: 'Plan', id: string, name: string, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, priceInCents: number }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> }, options: Array<{ __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } }> };

export type SummaryPrintConfigurationPlanFragment = { __typename?: 'Plan', id: string, name: string, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, priceInCents: number }> }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }> };

export type SummaryPrintConfigurationOptionFragment = { __typename?: 'ConfigurationOption', id: string, priceInCents: number, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } } };

export type SummaryPrintOptionFragment = { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, priceInCents: number, optionCode: string, bedrooms: number, fullBathrooms: number, halfBathrooms: number, garageAttached: number, garagePort: number, garageDetached: number, sqft: number, parentOption?: { __typename?: 'Option', id: string, name: string } | null | undefined, options: Array<{ __typename?: 'Option', id: string, name: string }>, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string, required: boolean, type: { __typename?: 'OptionTypeDetail', code: OptionType, name: string }, options: Array<{ __typename?: 'Option', id: string }> } };

export type SummaryPrintOptionImageFragment = { __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } };

export type SummaryPrintFloorPlanFragment = { __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string };

export type SummaryPropertyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SummaryPropertyQuery = { __typename?: 'Query', propertyByBlueprintId: { __typename?: 'Property', id: string, url?: string | null | undefined, city: string, postalCode: string, priceInCents: number, state: string, streetAddress: string, latitude: string, longitude: string, bedrooms: string, bathrooms: string, sqft: number, garageAttached: number, garagePort: number, isCustomizable: boolean, blueprintProjectId: string, tourUrl?: string | null | undefined, imageGallery: Array<{ __typename?: 'ImageGalleryImage', id: string, imageUrl: string, planLocation?: { __typename?: 'PlanLocation', id: string, name: string } | null | undefined }>, floorPlans: Array<{ __typename?: 'PropertyFloorPlan', id: string, name: string, imageUrl: string }>, baseConfiguration?: { __typename?: 'Configuration', id: string, plan: { __typename?: 'Plan', id: string, description?: string | null | undefined, features: Array<{ __typename?: 'PlanFeature', id: string, iconName: string, content: string }>, locations: Array<{ __typename?: 'PlanLocation', id: string, name: string, description: string, imageUrl: string }> }, elevation: { __typename?: 'Elevation', id: string, name: string, description: string } } | null | undefined, development: { __typename?: 'Development', id: string, market: { __typename?: 'Market', id: string, name: string, blueprintMarketId: string } }, mostRecentCutOff?: { __typename?: 'PropertyCutOff', id: string, cutOff: { __typename?: 'CutOff', id: string, marketingName: string, marketingHexColor: string } } | null | undefined } };

export type SummaryPropertyFragment = { __typename?: 'Property', id: string, url?: string | null | undefined, city: string, postalCode: string, priceInCents: number, state: string, streetAddress: string, latitude: string, longitude: string, bedrooms: string, bathrooms: string, sqft: number, garageAttached: number, garagePort: number, isCustomizable: boolean, blueprintProjectId: string, tourUrl?: string | null | undefined, imageGallery: Array<{ __typename?: 'ImageGalleryImage', id: string, imageUrl: string, planLocation?: { __typename?: 'PlanLocation', id: string, name: string } | null | undefined }>, floorPlans: Array<{ __typename?: 'PropertyFloorPlan', id: string, name: string, imageUrl: string }>, baseConfiguration?: { __typename?: 'Configuration', id: string, plan: { __typename?: 'Plan', id: string, description?: string | null | undefined, features: Array<{ __typename?: 'PlanFeature', id: string, iconName: string, content: string }>, locations: Array<{ __typename?: 'PlanLocation', id: string, name: string, description: string, imageUrl: string }> }, elevation: { __typename?: 'Elevation', id: string, name: string, description: string } } | null | undefined, development: { __typename?: 'Development', id: string, market: { __typename?: 'Market', id: string, name: string, blueprintMarketId: string } }, mostRecentCutOff?: { __typename?: 'PropertyCutOff', id: string, cutOff: { __typename?: 'CutOff', id: string, marketingName: string, marketingHexColor: string } } | null | undefined };

export type PropertyCoordinatesFragment = { __typename?: 'Property', id: string, latitude: string, longitude: string, streetAddress: string, city: string, state: string, postalCode: string };

export type ImageGalleryFragment = { __typename?: 'ImageGalleryImage', id: string, imageUrl: string, planLocation?: { __typename?: 'PlanLocation', id: string, name: string } | null | undefined };

export type FloorPlanFragment = { __typename?: 'PropertyFloorPlan', id: string, name: string, imageUrl: string };

export type PropertyConfigurationFragment = { __typename?: 'Configuration', id: string, plan: { __typename?: 'Plan', id: string, description?: string | null | undefined, features: Array<{ __typename?: 'PlanFeature', id: string, iconName: string, content: string }>, locations: Array<{ __typename?: 'PlanLocation', id: string, name: string, description: string, imageUrl: string }> }, elevation: { __typename?: 'Elevation', id: string, name: string, description: string } };

export type PropertyConfigurationPlanFragment = { __typename?: 'Plan', id: string, description?: string | null | undefined, features: Array<{ __typename?: 'PlanFeature', id: string, iconName: string, content: string }>, locations: Array<{ __typename?: 'PlanLocation', id: string, name: string, description: string, imageUrl: string }> };

export type PlanFeatureFragment = { __typename?: 'PlanFeature', id: string, iconName: string, content: string };

export type PlanLocationFragment = { __typename?: 'PlanLocation', id: string, name: string, description: string, imageUrl: string };

export type PlanElevationFragment = { __typename?: 'Elevation', id: string, name: string, description: string };

export type MarketPlansStepQueryVariables = Exact<{
  filter: MarketFilter;
}>;


export type MarketPlansStepQuery = { __typename?: 'Query', market: { __typename?: 'Market', id: string, developments: Array<{ __typename?: 'Development', id: string, plans: Array<{ __typename?: 'Plan', id: string, name: string, description?: string | null | undefined, tourUrl?: string | null | undefined, minGarageAttached: number, maxGarageAttached: number, minGaragePort: number, maxGaragePort: number, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, priceInCents: number, features: Array<{ __typename?: 'PlanFeature', id: string, content: string }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string } }> }> }> }> }> } };

export type MarketPlanStepPlanFragment = { __typename?: 'Plan', id: string, name: string, description?: string | null | undefined, tourUrl?: string | null | undefined, minGarageAttached: number, maxGarageAttached: number, minGaragePort: number, maxGaragePort: number, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, priceInCents: number, features: Array<{ __typename?: 'PlanFeature', id: string, content: string }>, floorPlans: Array<{ __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string }>, optionTypes: Array<{ __typename?: 'PlanOptionType', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string } }> }> }> };

export type MarketStepPlanOptionTypeFragment = { __typename?: 'PlanOptionType', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string } }> }> };

export type MarketStepParentOptionFragment = { __typename?: 'Option', id: string, name: string, options: Array<{ __typename?: 'Option', id: string, name: string, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string } }> };

export type MarketStepChildOptionFragment = { __typename?: 'Option', id: string, name: string, images: Array<{ __typename?: 'OptionImage', id: string, name: string, description?: string | null | undefined, imageUrl: string, type: { __typename?: 'OptionImageTypeDetail', code: OptionImageType } }>, planOptionType: { __typename?: 'PlanOptionType', id: string, name: string } };

export type MarketPlanStepFloorPlansFragment = { __typename?: 'PlanFloorPlan', id: string, name: string, imageUrl: string };

export type MarketPlanStepPropertyDetailsFragment = { __typename?: 'Plan', id: string, minBedrooms: number, maxBedrooms: number, minFullBathrooms: number, maxFullBathrooms: number, minHalfBathrooms: number, maxHalfBathrooms: number, minSqft: number, maxSqft: number, priceInCents: number };

export type LandingMarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type LandingMarketsQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, blueprintMarketId: string, propertyPriceMinInCents?: number | null | undefined, name: string, imageUrl: string }> };

export type LandingMarketFragment = { __typename?: 'Market', id: string, blueprintMarketId: string, propertyPriceMinInCents?: number | null | undefined, name: string, imageUrl: string };

export const ConfiguratorOptionConflictFragmentDoc = gql`
    fragment ConfiguratorOptionConflict on PlanOptionConflict {
  id
  optionCode
  conflictOptionCode
  reason
}
    `;
export const ConfiguratorOptionImageFragmentDoc = gql`
    fragment ConfiguratorOptionImage on OptionImage {
  id
  name
  description
  imageUrl
  type {
    code
  }
}
    `;
export const ConfiguratorOptionFragmentDoc = gql`
    fragment ConfiguratorOption on Option {
  id
  name
  description
  priceInCents
  optionCode
  bedrooms
  fullBathrooms
  halfBathrooms
  garageAttached
  garagePort
  garageDetached
  sqft
  included
  parentOption {
    id
    name
  }
  options {
    id
    name
  }
  images {
    ...ConfiguratorOptionImage
  }
  planOptionType {
    id
    name
    required
    type {
      code
      name
    }
    options {
      id
    }
  }
}
    ${ConfiguratorOptionImageFragmentDoc}`;
export const ConfiguratorPlanOptionTypeFragmentDoc = gql`
    fragment ConfiguratorPlanOptionType on PlanOptionType {
  id
  name
  required
  type {
    code
    name
  }
  options {
    ...ConfiguratorOption
  }
}
    ${ConfiguratorOptionFragmentDoc}`;
export const ConfiguratorFloorPlanFragmentDoc = gql`
    fragment ConfiguratorFloorPlan on PlanFloorPlan {
  id
  name
  imageUrl
}
    `;
export const ConfiguratorConfigurationPlanFragmentDoc = gql`
    fragment ConfiguratorConfigurationPlan on Plan {
  id
  minBedrooms
  maxBedrooms
  minFullBathrooms
  maxFullBathrooms
  minHalfBathrooms
  maxHalfBathrooms
  minSqft
  maxSqft
  name
  baseConfiguration {
    id
    options {
      id
      option {
        id
      }
    }
  }
  expirationDays
  optionConflicts {
    ...ConfiguratorOptionConflict
  }
  optionTypes {
    ...ConfiguratorPlanOptionType
  }
  floorPlans {
    ...ConfiguratorFloorPlan
  }
}
    ${ConfiguratorOptionConflictFragmentDoc}
${ConfiguratorPlanOptionTypeFragmentDoc}
${ConfiguratorFloorPlanFragmentDoc}`;
export const ConfiguratorConfigurationOptionFragmentDoc = gql`
    fragment ConfiguratorConfigurationOption on ConfigurationOption {
  id
  priceInCents
  option {
    ...ConfiguratorOption
  }
}
    ${ConfiguratorOptionFragmentDoc}`;
export const ContractedCustomerConfigurationFragmentDoc = gql`
    fragment ContractedCustomerConfiguration on CustomerConfiguration {
  id
  code
  planPriceInCents
  expiredAt
  reservedAt
  isReversed
  plan {
    tourUrl
    ...ConfiguratorConfigurationPlan
  }
  options {
    ...ConfiguratorConfigurationOption
  }
}
    ${ConfiguratorConfigurationPlanFragmentDoc}
${ConfiguratorConfigurationOptionFragmentDoc}`;
export const ConfigurationCustomerFragmentDoc = gql`
    fragment ConfigurationCustomer on Customer {
  id
  email
}
    `;
export const ConfiguratorConfigurationFragmentDoc = gql`
    fragment ConfiguratorConfiguration on CustomerConfiguration {
  id
  name
  code
  planPriceInCents
  expiredAt
  reservedAt
  status
  isReversed
  customer {
    ...ConfigurationCustomer
  }
  plan {
    ...ConfiguratorConfigurationPlan
  }
  options {
    ...ConfiguratorConfigurationOption
  }
}
    ${ConfigurationCustomerFragmentDoc}
${ConfiguratorConfigurationPlanFragmentDoc}
${ConfiguratorConfigurationOptionFragmentDoc}`;
export const ConfiguratorMarketFragmentDoc = gql`
    fragment ConfiguratorMarket on Market {
  id
  blueprintMarketId
  name
  imageUrl
}
    `;
export const InventoryMarketFragmentDoc = gql`
    fragment InventoryMarket on Market {
  id
  blueprintMarketId
  name
}
    `;
export const ImageGalleryFragmentDoc = gql`
    fragment ImageGallery on ImageGalleryImage {
  id
  imageUrl
  planLocation {
    id
    name
  }
}
    `;
export const CutOffFragmentDoc = gql`
    fragment CutOff on CutOff {
  id
  description
  marketingName
  marketingHexColor
}
    `;
export const InventoryPropertyFragmentDoc = gql`
    fragment InventoryProperty on Property {
  id
  streetAddress
  city
  state
  postalCode
  bathrooms
  bedrooms
  latitude
  longitude
  priceInCents
  sqft
  blueprintProjectId
  url
  isCustomizable
  imageGallery {
    ...ImageGallery
  }
  mostRecentCutOff {
    id
    cutOff {
      ...CutOff
    }
  }
}
    ${ImageGalleryFragmentDoc}
${CutOffFragmentDoc}`;
export const SummaryPrintFloorPlanFragmentDoc = gql`
    fragment SummaryPrintFloorPlan on PlanFloorPlan {
  id
  name
  imageUrl
}
    `;
export const SummaryPrintConfigurationPlanFragmentDoc = gql`
    fragment SummaryPrintConfigurationPlan on Plan {
  id
  name
  optionTypes {
    id
    name
    options {
      id
      name
      priceInCents
    }
  }
  floorPlans {
    ...SummaryPrintFloorPlan
  }
}
    ${SummaryPrintFloorPlanFragmentDoc}`;
export const SummaryPrintOptionImageFragmentDoc = gql`
    fragment SummaryPrintOptionImage on OptionImage {
  id
  name
  description
  imageUrl
  type {
    code
  }
}
    `;
export const SummaryPrintOptionFragmentDoc = gql`
    fragment SummaryPrintOption on Option {
  id
  name
  description
  priceInCents
  optionCode
  bedrooms
  fullBathrooms
  halfBathrooms
  garageAttached
  garagePort
  garageDetached
  sqft
  parentOption {
    id
    name
  }
  options {
    id
    name
  }
  images {
    ...SummaryPrintOptionImage
  }
  planOptionType {
    id
    name
    required
    type {
      code
      name
    }
    options {
      id
    }
  }
}
    ${SummaryPrintOptionImageFragmentDoc}`;
export const SummaryPrintConfigurationOptionFragmentDoc = gql`
    fragment SummaryPrintConfigurationOption on ConfigurationOption {
  id
  priceInCents
  option {
    ...SummaryPrintOption
  }
}
    ${SummaryPrintOptionFragmentDoc}`;
export const SummaryPrintConfigurationFragmentDoc = gql`
    fragment SummaryPrintConfiguration on CustomerConfiguration {
  id
  name
  code
  planPriceInCents
  expiredAt
  reservedAt
  status
  isReversed
  customer {
    id
    email
  }
  plan {
    ...SummaryPrintConfigurationPlan
  }
  options {
    ...SummaryPrintConfigurationOption
  }
}
    ${SummaryPrintConfigurationPlanFragmentDoc}
${SummaryPrintConfigurationOptionFragmentDoc}`;
export const FloorPlanFragmentDoc = gql`
    fragment FloorPlan on PropertyFloorPlan {
  id
  name
  imageUrl
}
    `;
export const PlanFeatureFragmentDoc = gql`
    fragment PlanFeature on PlanFeature {
  id
  iconName
  content
}
    `;
export const PlanLocationFragmentDoc = gql`
    fragment PlanLocation on PlanLocation {
  id
  name
  description
  imageUrl
}
    `;
export const PropertyConfigurationPlanFragmentDoc = gql`
    fragment PropertyConfigurationPlan on Plan {
  id
  description
  features {
    ...PlanFeature
  }
  locations {
    ...PlanLocation
  }
}
    ${PlanFeatureFragmentDoc}
${PlanLocationFragmentDoc}`;
export const PlanElevationFragmentDoc = gql`
    fragment PlanElevation on Elevation {
  id
  name
  description
}
    `;
export const PropertyConfigurationFragmentDoc = gql`
    fragment PropertyConfiguration on Configuration {
  id
  plan {
    ...PropertyConfigurationPlan
  }
  elevation {
    ...PlanElevation
  }
}
    ${PropertyConfigurationPlanFragmentDoc}
${PlanElevationFragmentDoc}`;
export const PropertyCoordinatesFragmentDoc = gql`
    fragment PropertyCoordinates on Property {
  id
  latitude
  longitude
  streetAddress
  city
  state
  postalCode
}
    `;
export const SummaryPropertyFragmentDoc = gql`
    fragment SummaryProperty on Property {
  id
  url
  city
  postalCode
  priceInCents
  state
  streetAddress
  latitude
  longitude
  bedrooms
  bathrooms
  sqft
  garageAttached
  garagePort
  isCustomizable
  blueprintProjectId
  tourUrl
  imageGallery {
    ...ImageGallery
  }
  floorPlans {
    ...FloorPlan
  }
  baseConfiguration {
    ...PropertyConfiguration
  }
  development {
    id
    market {
      id
      name
      blueprintMarketId
    }
  }
  mostRecentCutOff {
    id
    cutOff {
      id
      marketingName
      marketingHexColor
    }
  }
  ...PropertyCoordinates
}
    ${ImageGalleryFragmentDoc}
${FloorPlanFragmentDoc}
${PropertyConfigurationFragmentDoc}
${PropertyCoordinatesFragmentDoc}`;
export const MarketPlanStepFloorPlansFragmentDoc = gql`
    fragment MarketPlanStepFloorPlans on PlanFloorPlan {
  id
  name
  imageUrl
}
    `;
export const MarketStepChildOptionFragmentDoc = gql`
    fragment marketStepChildOption on Option {
  id
  name
  images {
    id
    name
    description
    imageUrl
    type {
      code
    }
  }
  planOptionType {
    id
    name
  }
}
    `;
export const MarketStepParentOptionFragmentDoc = gql`
    fragment MarketStepParentOption on Option {
  id
  name
  options {
    ...marketStepChildOption
  }
}
    ${MarketStepChildOptionFragmentDoc}`;
export const MarketStepPlanOptionTypeFragmentDoc = gql`
    fragment MarketStepPlanOptionType on PlanOptionType {
  id
  name
  options {
    ...MarketStepParentOption
  }
}
    ${MarketStepParentOptionFragmentDoc}`;
export const MarketPlanStepPropertyDetailsFragmentDoc = gql`
    fragment MarketPlanStepPropertyDetails on Plan {
  id
  minBedrooms
  maxBedrooms
  minFullBathrooms
  maxFullBathrooms
  minHalfBathrooms
  maxHalfBathrooms
  minSqft
  maxSqft
  priceInCents
}
    `;
export const MarketPlanStepPlanFragmentDoc = gql`
    fragment MarketPlanStepPlan on Plan {
  id
  name
  description
  tourUrl
  features {
    id
    content
  }
  minGarageAttached
  maxGarageAttached
  minGaragePort
  maxGaragePort
  floorPlans {
    ...MarketPlanStepFloorPlans
  }
  optionTypes(filter: {name: ["Exterior"]}) {
    ...MarketStepPlanOptionType
  }
  ...MarketPlanStepPropertyDetails
}
    ${MarketPlanStepFloorPlansFragmentDoc}
${MarketStepPlanOptionTypeFragmentDoc}
${MarketPlanStepPropertyDetailsFragmentDoc}`;
export const LandingMarketFragmentDoc = gql`
    fragment LandingMarket on Market {
  id
  blueprintMarketId
  propertyPriceMinInCents
  name
  imageUrl
}
    `;
export const ContractedCustomerConfigurationByCodeDocument = gql`
    query ContractedCustomerConfigurationByCode($code: String!) {
  customerConfiguration(filter: {code: $code}) {
    ...ContractedCustomerConfiguration
  }
}
    ${ContractedCustomerConfigurationFragmentDoc}`;

/**
 * __useContractedCustomerConfigurationByCodeQuery__
 *
 * To run a query within a React component, call `useContractedCustomerConfigurationByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractedCustomerConfigurationByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractedCustomerConfigurationByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useContractedCustomerConfigurationByCodeQuery(baseOptions: Apollo.QueryHookOptions<ContractedCustomerConfigurationByCodeQuery, ContractedCustomerConfigurationByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractedCustomerConfigurationByCodeQuery, ContractedCustomerConfigurationByCodeQueryVariables>(ContractedCustomerConfigurationByCodeDocument, options);
      }
export function useContractedCustomerConfigurationByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractedCustomerConfigurationByCodeQuery, ContractedCustomerConfigurationByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractedCustomerConfigurationByCodeQuery, ContractedCustomerConfigurationByCodeQueryVariables>(ContractedCustomerConfigurationByCodeDocument, options);
        }
export type ContractedCustomerConfigurationByCodeQueryHookResult = ReturnType<typeof useContractedCustomerConfigurationByCodeQuery>;
export type ContractedCustomerConfigurationByCodeLazyQueryHookResult = ReturnType<typeof useContractedCustomerConfigurationByCodeLazyQuery>;
export type ContractedCustomerConfigurationByCodeQueryResult = Apollo.QueryResult<ContractedCustomerConfigurationByCodeQuery, ContractedCustomerConfigurationByCodeQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: SaveCustomerInput!) {
  createCustomer(input: $input) {
    emptyResult
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CustomerConfigurationByCodeDocument = gql`
    query CustomerConfigurationByCode($code: String!) {
  customerConfiguration(filter: {code: $code}) {
    ...ConfiguratorConfiguration
  }
}
    ${ConfiguratorConfigurationFragmentDoc}`;

/**
 * __useCustomerConfigurationByCodeQuery__
 *
 * To run a query within a React component, call `useCustomerConfigurationByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerConfigurationByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerConfigurationByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCustomerConfigurationByCodeQuery(baseOptions: Apollo.QueryHookOptions<CustomerConfigurationByCodeQuery, CustomerConfigurationByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerConfigurationByCodeQuery, CustomerConfigurationByCodeQueryVariables>(CustomerConfigurationByCodeDocument, options);
      }
export function useCustomerConfigurationByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerConfigurationByCodeQuery, CustomerConfigurationByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerConfigurationByCodeQuery, CustomerConfigurationByCodeQueryVariables>(CustomerConfigurationByCodeDocument, options);
        }
export type CustomerConfigurationByCodeQueryHookResult = ReturnType<typeof useCustomerConfigurationByCodeQuery>;
export type CustomerConfigurationByCodeLazyQueryHookResult = ReturnType<typeof useCustomerConfigurationByCodeLazyQuery>;
export type CustomerConfigurationByCodeQueryResult = Apollo.QueryResult<CustomerConfigurationByCodeQuery, CustomerConfigurationByCodeQueryVariables>;
export const SaveCustomerConfigurationDocument = gql`
    mutation SaveCustomerConfiguration($input: SaveCustomerConfigurationInput!) {
  saveCustomerConfiguration(input: $input) {
    customerConfiguration {
      ...ConfiguratorConfiguration
    }
  }
}
    ${ConfiguratorConfigurationFragmentDoc}`;
export type SaveCustomerConfigurationMutationFn = Apollo.MutationFunction<SaveCustomerConfigurationMutation, SaveCustomerConfigurationMutationVariables>;

/**
 * __useSaveCustomerConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveCustomerConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomerConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomerConfigurationMutation, { data, loading, error }] = useSaveCustomerConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCustomerConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomerConfigurationMutation, SaveCustomerConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomerConfigurationMutation, SaveCustomerConfigurationMutationVariables>(SaveCustomerConfigurationDocument, options);
      }
export type SaveCustomerConfigurationMutationHookResult = ReturnType<typeof useSaveCustomerConfigurationMutation>;
export type SaveCustomerConfigurationMutationResult = Apollo.MutationResult<SaveCustomerConfigurationMutation>;
export type SaveCustomerConfigurationMutationOptions = Apollo.BaseMutationOptions<SaveCustomerConfigurationMutation, SaveCustomerConfigurationMutationVariables>;
export const SaveNewCustomerConfigurationDocument = gql`
    mutation SaveNewCustomerConfiguration($input: SaveCustomerConfigurationInput!) {
  saveCustomerConfiguration(input: $input) {
    customerConfiguration {
      id
      code
    }
  }
}
    `;
export type SaveNewCustomerConfigurationMutationFn = Apollo.MutationFunction<SaveNewCustomerConfigurationMutation, SaveNewCustomerConfigurationMutationVariables>;

/**
 * __useSaveNewCustomerConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveNewCustomerConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNewCustomerConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNewCustomerConfigurationMutation, { data, loading, error }] = useSaveNewCustomerConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNewCustomerConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SaveNewCustomerConfigurationMutation, SaveNewCustomerConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNewCustomerConfigurationMutation, SaveNewCustomerConfigurationMutationVariables>(SaveNewCustomerConfigurationDocument, options);
      }
export type SaveNewCustomerConfigurationMutationHookResult = ReturnType<typeof useSaveNewCustomerConfigurationMutation>;
export type SaveNewCustomerConfigurationMutationResult = Apollo.MutationResult<SaveNewCustomerConfigurationMutation>;
export type SaveNewCustomerConfigurationMutationOptions = Apollo.BaseMutationOptions<SaveNewCustomerConfigurationMutation, SaveNewCustomerConfigurationMutationVariables>;
export const DuplicateCustomerConfigurationDocument = gql`
    mutation DuplicateCustomerConfiguration($input: DuplicateCustomerConfigurationInput!) {
  duplicateCustomerConfiguration(input: $input) {
    customerConfiguration {
      id
      code
    }
  }
}
    `;
export type DuplicateCustomerConfigurationMutationFn = Apollo.MutationFunction<DuplicateCustomerConfigurationMutation, DuplicateCustomerConfigurationMutationVariables>;

/**
 * __useDuplicateCustomerConfigurationMutation__
 *
 * To run a mutation, you first call `useDuplicateCustomerConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCustomerConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCustomerConfigurationMutation, { data, loading, error }] = useDuplicateCustomerConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateCustomerConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateCustomerConfigurationMutation, DuplicateCustomerConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateCustomerConfigurationMutation, DuplicateCustomerConfigurationMutationVariables>(DuplicateCustomerConfigurationDocument, options);
      }
export type DuplicateCustomerConfigurationMutationHookResult = ReturnType<typeof useDuplicateCustomerConfigurationMutation>;
export type DuplicateCustomerConfigurationMutationResult = Apollo.MutationResult<DuplicateCustomerConfigurationMutation>;
export type DuplicateCustomerConfigurationMutationOptions = Apollo.BaseMutationOptions<DuplicateCustomerConfigurationMutation, DuplicateCustomerConfigurationMutationVariables>;
export const ToggleOptionDocument = gql`
    mutation ToggleOption($input: SaveCustomerConfigurationInput!) {
  saveCustomerConfiguration(input: $input) {
    customerConfiguration {
      id
      options {
        ...ConfiguratorConfigurationOption
      }
    }
  }
}
    ${ConfiguratorConfigurationOptionFragmentDoc}`;
export type ToggleOptionMutationFn = Apollo.MutationFunction<ToggleOptionMutation, ToggleOptionMutationVariables>;

/**
 * __useToggleOptionMutation__
 *
 * To run a mutation, you first call `useToggleOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleOptionMutation, { data, loading, error }] = useToggleOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleOptionMutation(baseOptions?: Apollo.MutationHookOptions<ToggleOptionMutation, ToggleOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleOptionMutation, ToggleOptionMutationVariables>(ToggleOptionDocument, options);
      }
export type ToggleOptionMutationHookResult = ReturnType<typeof useToggleOptionMutation>;
export type ToggleOptionMutationResult = Apollo.MutationResult<ToggleOptionMutation>;
export type ToggleOptionMutationOptions = Apollo.BaseMutationOptions<ToggleOptionMutation, ToggleOptionMutationVariables>;
export const InternalConfiguratorMarketsDocument = gql`
    query InternalConfiguratorMarkets {
  markets {
    ...ConfiguratorMarket
  }
}
    ${ConfiguratorMarketFragmentDoc}`;

/**
 * __useInternalConfiguratorMarketsQuery__
 *
 * To run a query within a React component, call `useInternalConfiguratorMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalConfiguratorMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalConfiguratorMarketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalConfiguratorMarketsQuery(baseOptions?: Apollo.QueryHookOptions<InternalConfiguratorMarketsQuery, InternalConfiguratorMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalConfiguratorMarketsQuery, InternalConfiguratorMarketsQueryVariables>(InternalConfiguratorMarketsDocument, options);
      }
export function useInternalConfiguratorMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalConfiguratorMarketsQuery, InternalConfiguratorMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalConfiguratorMarketsQuery, InternalConfiguratorMarketsQueryVariables>(InternalConfiguratorMarketsDocument, options);
        }
export type InternalConfiguratorMarketsQueryHookResult = ReturnType<typeof useInternalConfiguratorMarketsQuery>;
export type InternalConfiguratorMarketsLazyQueryHookResult = ReturnType<typeof useInternalConfiguratorMarketsLazyQuery>;
export type InternalConfiguratorMarketsQueryResult = Apollo.QueryResult<InternalConfiguratorMarketsQuery, InternalConfiguratorMarketsQueryVariables>;
export const InventoryFiltersDocument = gql`
    query InventoryFilters {
  markets {
    ...InventoryMarket
  }
  cutOffs {
    ...CutOff
  }
}
    ${InventoryMarketFragmentDoc}
${CutOffFragmentDoc}`;

/**
 * __useInventoryFiltersQuery__
 *
 * To run a query within a React component, call `useInventoryFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryFiltersQuery(baseOptions?: Apollo.QueryHookOptions<InventoryFiltersQuery, InventoryFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryFiltersQuery, InventoryFiltersQueryVariables>(InventoryFiltersDocument, options);
      }
export function useInventoryFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryFiltersQuery, InventoryFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryFiltersQuery, InventoryFiltersQueryVariables>(InventoryFiltersDocument, options);
        }
export type InventoryFiltersQueryHookResult = ReturnType<typeof useInventoryFiltersQuery>;
export type InventoryFiltersLazyQueryHookResult = ReturnType<typeof useInventoryFiltersLazyQuery>;
export type InventoryFiltersQueryResult = Apollo.QueryResult<InventoryFiltersQuery, InventoryFiltersQueryVariables>;
export const InventoryPropertiesDocument = gql`
    query InventoryProperties($filter: PropertyFilter!) {
  properties(filter: $filter) {
    ...InventoryProperty
  }
}
    ${InventoryPropertyFragmentDoc}`;

/**
 * __useInventoryPropertiesQuery__
 *
 * To run a query within a React component, call `useInventoryPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryPropertiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInventoryPropertiesQuery(baseOptions: Apollo.QueryHookOptions<InventoryPropertiesQuery, InventoryPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryPropertiesQuery, InventoryPropertiesQueryVariables>(InventoryPropertiesDocument, options);
      }
export function useInventoryPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryPropertiesQuery, InventoryPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryPropertiesQuery, InventoryPropertiesQueryVariables>(InventoryPropertiesDocument, options);
        }
export type InventoryPropertiesQueryHookResult = ReturnType<typeof useInventoryPropertiesQuery>;
export type InventoryPropertiesLazyQueryHookResult = ReturnType<typeof useInventoryPropertiesLazyQuery>;
export type InventoryPropertiesQueryResult = Apollo.QueryResult<InventoryPropertiesQuery, InventoryPropertiesQueryVariables>;
export const SummaryPrintConfigurationDocument = gql`
    query SummaryPrintConfiguration($code: String!) {
  customerConfiguration(filter: {code: $code}) {
    ...ConfiguratorConfiguration
  }
}
    ${ConfiguratorConfigurationFragmentDoc}`;

/**
 * __useSummaryPrintConfigurationQuery__
 *
 * To run a query within a React component, call `useSummaryPrintConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryPrintConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryPrintConfigurationQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSummaryPrintConfigurationQuery(baseOptions: Apollo.QueryHookOptions<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>(SummaryPrintConfigurationDocument, options);
      }
export function useSummaryPrintConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>(SummaryPrintConfigurationDocument, options);
        }
export type SummaryPrintConfigurationQueryHookResult = ReturnType<typeof useSummaryPrintConfigurationQuery>;
export type SummaryPrintConfigurationLazyQueryHookResult = ReturnType<typeof useSummaryPrintConfigurationLazyQuery>;
export type SummaryPrintConfigurationQueryResult = Apollo.QueryResult<SummaryPrintConfigurationQuery, SummaryPrintConfigurationQueryVariables>;
export const SummaryPropertyDocument = gql`
    query SummaryProperty($id: ID!) {
  propertyByBlueprintId(id: $id) {
    ...SummaryProperty
  }
}
    ${SummaryPropertyFragmentDoc}`;

/**
 * __useSummaryPropertyQuery__
 *
 * To run a query within a React component, call `useSummaryPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryPropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSummaryPropertyQuery(baseOptions: Apollo.QueryHookOptions<SummaryPropertyQuery, SummaryPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryPropertyQuery, SummaryPropertyQueryVariables>(SummaryPropertyDocument, options);
      }
export function useSummaryPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryPropertyQuery, SummaryPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryPropertyQuery, SummaryPropertyQueryVariables>(SummaryPropertyDocument, options);
        }
export type SummaryPropertyQueryHookResult = ReturnType<typeof useSummaryPropertyQuery>;
export type SummaryPropertyLazyQueryHookResult = ReturnType<typeof useSummaryPropertyLazyQuery>;
export type SummaryPropertyQueryResult = Apollo.QueryResult<SummaryPropertyQuery, SummaryPropertyQueryVariables>;
export const MarketPlansStepDocument = gql`
    query MarketPlansStep($filter: MarketFilter!) {
  market(filter: $filter) {
    id
    developments {
      id
      plans {
        ...MarketPlanStepPlan
      }
    }
  }
}
    ${MarketPlanStepPlanFragmentDoc}`;

/**
 * __useMarketPlansStepQuery__
 *
 * To run a query within a React component, call `useMarketPlansStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketPlansStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketPlansStepQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketPlansStepQuery(baseOptions: Apollo.QueryHookOptions<MarketPlansStepQuery, MarketPlansStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketPlansStepQuery, MarketPlansStepQueryVariables>(MarketPlansStepDocument, options);
      }
export function useMarketPlansStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketPlansStepQuery, MarketPlansStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketPlansStepQuery, MarketPlansStepQueryVariables>(MarketPlansStepDocument, options);
        }
export type MarketPlansStepQueryHookResult = ReturnType<typeof useMarketPlansStepQuery>;
export type MarketPlansStepLazyQueryHookResult = ReturnType<typeof useMarketPlansStepLazyQuery>;
export type MarketPlansStepQueryResult = Apollo.QueryResult<MarketPlansStepQuery, MarketPlansStepQueryVariables>;
export const LandingMarketsDocument = gql`
    query LandingMarkets {
  markets {
    ...LandingMarket
  }
}
    ${LandingMarketFragmentDoc}`;

/**
 * __useLandingMarketsQuery__
 *
 * To run a query within a React component, call `useLandingMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingMarketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLandingMarketsQuery(baseOptions?: Apollo.QueryHookOptions<LandingMarketsQuery, LandingMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingMarketsQuery, LandingMarketsQueryVariables>(LandingMarketsDocument, options);
      }
export function useLandingMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingMarketsQuery, LandingMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingMarketsQuery, LandingMarketsQueryVariables>(LandingMarketsDocument, options);
        }
export type LandingMarketsQueryHookResult = ReturnType<typeof useLandingMarketsQuery>;
export type LandingMarketsLazyQueryHookResult = ReturnType<typeof useLandingMarketsLazyQuery>;
export type LandingMarketsQueryResult = Apollo.QueryResult<LandingMarketsQuery, LandingMarketsQueryVariables>;
import { newDate, newDateTime } from "src/utils/tests/testDates";

const factories: Record<string, Function> = {};
export interface AssetOptions {
  __typename?: "Asset";
  id?: Asset["id"];
  contentType?: Asset["contentType"];
  downloadUrl?: Asset["downloadUrl"];
  attachmentUrl?: Asset["attachmentUrl"];
  previewUrl?: Asset["previewUrl"];
  url?: Asset["url"];
  fileName?: Asset["fileName"];
  sizeInBytes?: Asset["sizeInBytes"];
  createdAt?: Asset["createdAt"];
  updatedAt?: Asset["updatedAt"];
  version?: Asset["version"];
}

export function newAsset(options: AssetOptions = {}, cache: Record<string, any> = {}): Asset {
  const o = (options.__typename ? options : cache["Asset"] = {}) as Asset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Asset";
  o.id = options.id ?? nextFactoryId("Asset");
  o.contentType = options.contentType ?? "contentType";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  o.url = options.url ?? "url";
  o.fileName = options.fileName ?? null;
  o.sizeInBytes = options.sizeInBytes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.version = options.version ?? "version";
  return o;
}

factories["Asset"] = newAsset;

function maybeNewAsset(value: AssetOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Asset {
  if (value === undefined) {
    return isSet ? undefined : cache["Asset"] || newAsset({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newAsset(value, cache);
  }
}

function maybeNewOrNullAsset(value: AssetOptions | undefined | null, cache: Record<string, any>): Asset | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newAsset(value, cache);
  }
}
export interface CreateAssetUploadUrlResultOptions {
  __typename?: "CreateAssetUploadUrlResult";
  s3Key?: CreateAssetUploadUrlResult["s3Key"];
  uploadUrl?: CreateAssetUploadUrlResult["uploadUrl"];
  downloadUrl?: CreateAssetUploadUrlResult["downloadUrl"];
  attachmentUrl?: CreateAssetUploadUrlResult["attachmentUrl"];
  previewUrl?: CreateAssetUploadUrlResult["previewUrl"];
}

export function newCreateAssetUploadUrlResult(
  options: CreateAssetUploadUrlResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetUploadUrlResult {
  const o = (options.__typename ? options : cache["CreateAssetUploadUrlResult"] = {}) as CreateAssetUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetUploadUrlResult";
  o.s3Key = options.s3Key ?? "s3Key";
  o.uploadUrl = options.uploadUrl ?? "uploadUrl";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  return o;
}

factories["CreateAssetUploadUrlResult"] = newCreateAssetUploadUrlResult;

function maybeNewCreateAssetUploadUrlResult(
  value: CreateAssetUploadUrlResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): CreateAssetUploadUrlResult {
  if (value === undefined) {
    return isSet ? undefined : cache["CreateAssetUploadUrlResult"] || newCreateAssetUploadUrlResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCreateAssetUploadUrlResult(value, cache);
  }
}

function maybeNewOrNullCreateAssetUploadUrlResult(
  value: CreateAssetUploadUrlResultOptions | undefined | null,
  cache: Record<string, any>,
): CreateAssetUploadUrlResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCreateAssetUploadUrlResult(value, cache);
  }
}
export interface BaseConfigurationOptions {
  __typename?: "BaseConfiguration";
  id?: BaseConfiguration["id"];
  airtableId?: BaseConfiguration["airtableId"];
  createdAt?: BaseConfiguration["createdAt"];
  updatedAt?: BaseConfiguration["updatedAt"];
  plan?: PlanOptions;
  options?: Array<ConfigurationOptionOptions>;
}

export function newBaseConfiguration(
  options: BaseConfigurationOptions = {},
  cache: Record<string, any> = {},
): BaseConfiguration {
  const o = (options.__typename ? options : cache["BaseConfiguration"] = {}) as BaseConfiguration;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BaseConfiguration";
  o.id = options.id ?? nextFactoryId("BaseConfiguration");
  o.airtableId = options.airtableId ?? "airtableId";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  o.options = (options.options ?? []).map((i) =>
    maybeNewConfigurationOption(i, cache, options.hasOwnProperty("options"))
  );
  return o;
}

factories["BaseConfiguration"] = newBaseConfiguration;

function maybeNewBaseConfiguration(
  value: BaseConfigurationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): BaseConfiguration {
  if (value === undefined) {
    return isSet ? undefined : cache["BaseConfiguration"] || newBaseConfiguration({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newBaseConfiguration(value, cache);
  }
}

function maybeNewOrNullBaseConfiguration(
  value: BaseConfigurationOptions | undefined | null,
  cache: Record<string, any>,
): BaseConfiguration | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newBaseConfiguration(value, cache);
  }
}
export interface ImportBaseConfigurationResultOptions {
  __typename?: "ImportBaseConfigurationResult";
  baseConfigurations?: Array<BaseConfigurationOptions>;
}

export function newImportBaseConfigurationResult(
  options: ImportBaseConfigurationResultOptions = {},
  cache: Record<string, any> = {},
): ImportBaseConfigurationResult {
  const o =
    (options.__typename ? options : cache["ImportBaseConfigurationResult"] = {}) as ImportBaseConfigurationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportBaseConfigurationResult";
  o.baseConfigurations = (options.baseConfigurations ?? []).map((i) =>
    maybeNewBaseConfiguration(i, cache, options.hasOwnProperty("baseConfigurations"))
  );
  return o;
}

factories["ImportBaseConfigurationResult"] = newImportBaseConfigurationResult;

function maybeNewImportBaseConfigurationResult(
  value: ImportBaseConfigurationResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportBaseConfigurationResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportBaseConfigurationResult"] || newImportBaseConfigurationResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportBaseConfigurationResult(value, cache);
  }
}

function maybeNewOrNullImportBaseConfigurationResult(
  value: ImportBaseConfigurationResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportBaseConfigurationResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportBaseConfigurationResult(value, cache);
  }
}
export interface ConfigurationOptions {
  __typename?: "Configuration";
  id?: Configuration["id"];
  airtableId?: Configuration["airtableId"];
  createdAt?: Configuration["createdAt"];
  updatedAt?: Configuration["updatedAt"];
  elevation?: ElevationOptions;
  property?: PropertyOptions;
  specLevel?: SpecLevelOptions;
  plan?: PlanOptions;
}

export function newConfiguration(options: ConfigurationOptions = {}, cache: Record<string, any> = {}): Configuration {
  const o = (options.__typename ? options : cache["Configuration"] = {}) as Configuration;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Configuration";
  o.id = options.id ?? nextFactoryId("Configuration");
  o.airtableId = options.airtableId ?? "airtableId";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevation = maybeNewElevation(options.elevation, cache, options.hasOwnProperty("elevation"));
  o.property = maybeNewProperty(options.property, cache, options.hasOwnProperty("property"));
  o.specLevel = maybeNewSpecLevel(options.specLevel, cache, options.hasOwnProperty("specLevel"));
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  return o;
}

factories["Configuration"] = newConfiguration;

function maybeNewConfiguration(
  value: ConfigurationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Configuration {
  if (value === undefined) {
    return isSet ? undefined : cache["Configuration"] || newConfiguration({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newConfiguration(value, cache);
  }
}

function maybeNewOrNullConfiguration(
  value: ConfigurationOptions | undefined | null,
  cache: Record<string, any>,
): Configuration | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newConfiguration(value, cache);
  }
}
export interface ImportConfigurationResultOptions {
  __typename?: "ImportConfigurationResult";
  configurations?: Array<ConfigurationOptions>;
}

export function newImportConfigurationResult(
  options: ImportConfigurationResultOptions = {},
  cache: Record<string, any> = {},
): ImportConfigurationResult {
  const o = (options.__typename ? options : cache["ImportConfigurationResult"] = {}) as ImportConfigurationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportConfigurationResult";
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  return o;
}

factories["ImportConfigurationResult"] = newImportConfigurationResult;

function maybeNewImportConfigurationResult(
  value: ImportConfigurationResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportConfigurationResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportConfigurationResult"] || newImportConfigurationResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportConfigurationResult(value, cache);
  }
}

function maybeNewOrNullImportConfigurationResult(
  value: ImportConfigurationResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportConfigurationResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportConfigurationResult(value, cache);
  }
}
export interface ConfigurationOptionOptions {
  __typename?: "ConfigurationOption";
  id?: ConfigurationOption["id"];
  priceInCents?: ConfigurationOption["priceInCents"];
  baseConfiguration?: BaseConfigurationOptions | null;
  customerConfiguration?: CustomerConfigurationOptions | null;
  option?: OptionOptions;
}

export function newConfigurationOption(
  options: ConfigurationOptionOptions = {},
  cache: Record<string, any> = {},
): ConfigurationOption {
  const o = (options.__typename ? options : cache["ConfigurationOption"] = {}) as ConfigurationOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConfigurationOption";
  o.id = options.id ?? nextFactoryId("ConfigurationOption");
  o.priceInCents = options.priceInCents ?? 0;
  o.baseConfiguration = maybeNewOrNullBaseConfiguration(options.baseConfiguration, cache);
  o.customerConfiguration = maybeNewOrNullCustomerConfiguration(options.customerConfiguration, cache);
  o.option = maybeNewOption(options.option, cache, options.hasOwnProperty("option"));
  return o;
}

factories["ConfigurationOption"] = newConfigurationOption;

function maybeNewConfigurationOption(
  value: ConfigurationOptionOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ConfigurationOption {
  if (value === undefined) {
    return isSet ? undefined : cache["ConfigurationOption"] || newConfigurationOption({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newConfigurationOption(value, cache);
  }
}

function maybeNewOrNullConfigurationOption(
  value: ConfigurationOptionOptions | undefined | null,
  cache: Record<string, any>,
): ConfigurationOption | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newConfigurationOption(value, cache);
  }
}
export interface BaseConfigurationOptionResultOptions {
  __typename?: "BaseConfigurationOptionResult";
  configurationOptions?: Array<ConfigurationOptionOptions>;
}

export function newBaseConfigurationOptionResult(
  options: BaseConfigurationOptionResultOptions = {},
  cache: Record<string, any> = {},
): BaseConfigurationOptionResult {
  const o =
    (options.__typename ? options : cache["BaseConfigurationOptionResult"] = {}) as BaseConfigurationOptionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BaseConfigurationOptionResult";
  o.configurationOptions = (options.configurationOptions ?? []).map((i) =>
    maybeNewConfigurationOption(i, cache, options.hasOwnProperty("configurationOptions"))
  );
  return o;
}

factories["BaseConfigurationOptionResult"] = newBaseConfigurationOptionResult;

function maybeNewBaseConfigurationOptionResult(
  value: BaseConfigurationOptionResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): BaseConfigurationOptionResult {
  if (value === undefined) {
    return isSet ? undefined : cache["BaseConfigurationOptionResult"] || newBaseConfigurationOptionResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newBaseConfigurationOptionResult(value, cache);
  }
}

function maybeNewOrNullBaseConfigurationOptionResult(
  value: BaseConfigurationOptionResultOptions | undefined | null,
  cache: Record<string, any>,
): BaseConfigurationOptionResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newBaseConfigurationOptionResult(value, cache);
  }
}
export interface CustomerOptions {
  __typename?: "Customer";
  id?: Customer["id"];
  firstName?: Customer["firstName"];
  lastName?: Customer["lastName"];
  email?: Customer["email"];
  phoneNumber?: Customer["phoneNumber"];
  property?: PropertyOptions | null;
}

export function newCustomer(options: CustomerOptions = {}, cache: Record<string, any> = {}): Customer {
  const o = (options.__typename ? options : cache["Customer"] = {}) as Customer;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Customer";
  o.id = options.id ?? nextFactoryId("Customer");
  o.firstName = options.firstName ?? null;
  o.lastName = options.lastName ?? null;
  o.email = options.email ?? "email";
  o.phoneNumber = options.phoneNumber ?? null;
  o.property = maybeNewOrNullProperty(options.property, cache);
  return o;
}

factories["Customer"] = newCustomer;

function maybeNewCustomer(
  value: CustomerOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Customer {
  if (value === undefined) {
    return isSet ? undefined : cache["Customer"] || newCustomer({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCustomer(value, cache);
  }
}

function maybeNewOrNullCustomer(
  value: CustomerOptions | undefined | null,
  cache: Record<string, any>,
): Customer | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCustomer(value, cache);
  }
}
export interface ImportCustomersResultOptions {
  __typename?: "ImportCustomersResult";
  customers?: Array<CustomerOptions>;
}

export function newImportCustomersResult(
  options: ImportCustomersResultOptions = {},
  cache: Record<string, any> = {},
): ImportCustomersResult {
  const o = (options.__typename ? options : cache["ImportCustomersResult"] = {}) as ImportCustomersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportCustomersResult";
  o.customers = (options.customers ?? []).map((i) => maybeNewCustomer(i, cache, options.hasOwnProperty("customers")));
  return o;
}

factories["ImportCustomersResult"] = newImportCustomersResult;

function maybeNewImportCustomersResult(
  value: ImportCustomersResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportCustomersResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportCustomersResult"] || newImportCustomersResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportCustomersResult(value, cache);
  }
}

function maybeNewOrNullImportCustomersResult(
  value: ImportCustomersResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportCustomersResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportCustomersResult(value, cache);
  }
}
export interface CustomerConfigurationOptions {
  __typename?: "CustomerConfiguration";
  id?: CustomerConfiguration["id"];
  code?: CustomerConfiguration["code"];
  name?: CustomerConfiguration["name"];
  reservedAt?: CustomerConfiguration["reservedAt"];
  expiredAt?: CustomerConfiguration["expiredAt"];
  customer?: CustomerOptions | null;
  plan?: PlanOptions;
  isReversed?: CustomerConfiguration["isReversed"];
  options?: Array<ConfigurationOptionOptions>;
  planPriceInCents?: CustomerConfiguration["planPriceInCents"];
  status?: CustomerConfiguration["status"];
  originalCustomerConfiguration?: CustomerConfigurationOptions | null;
}

export function newCustomerConfiguration(
  options: CustomerConfigurationOptions = {},
  cache: Record<string, any> = {},
): CustomerConfiguration {
  const o = (options.__typename ? options : cache["CustomerConfiguration"] = {}) as CustomerConfiguration;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CustomerConfiguration";
  o.id = options.id ?? nextFactoryId("CustomerConfiguration");
  o.code = options.code ?? "code";
  o.name = options.name ?? null;
  o.reservedAt = options.reservedAt ?? null;
  o.expiredAt = options.expiredAt ?? null;
  o.customer = maybeNewOrNullCustomer(options.customer, cache);
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  o.isReversed = options.isReversed ?? false;
  o.options = (options.options ?? []).map((i) =>
    maybeNewConfigurationOption(i, cache, options.hasOwnProperty("options"))
  );
  o.planPriceInCents = options.planPriceInCents ?? 0;
  o.status = options.status ?? CustomerConfigurationStatus.Draft;
  o.originalCustomerConfiguration = maybeNewOrNullCustomerConfiguration(options.originalCustomerConfiguration, cache);
  return o;
}

factories["CustomerConfiguration"] = newCustomerConfiguration;

function maybeNewCustomerConfiguration(
  value: CustomerConfigurationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): CustomerConfiguration {
  if (value === undefined) {
    return isSet ? undefined : cache["CustomerConfiguration"] || newCustomerConfiguration({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCustomerConfiguration(value, cache);
  }
}

function maybeNewOrNullCustomerConfiguration(
  value: CustomerConfigurationOptions | undefined | null,
  cache: Record<string, any>,
): CustomerConfiguration | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCustomerConfiguration(value, cache);
  }
}
export interface SaveCustomerConfigurationResultOptions {
  __typename?: "SaveCustomerConfigurationResult";
  customerConfiguration?: CustomerConfigurationOptions;
}

export function newSaveCustomerConfigurationResult(
  options: SaveCustomerConfigurationResultOptions = {},
  cache: Record<string, any> = {},
): SaveCustomerConfigurationResult {
  const o =
    (options.__typename ? options : cache["SaveCustomerConfigurationResult"] = {}) as SaveCustomerConfigurationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCustomerConfigurationResult";
  o.customerConfiguration = maybeNewCustomerConfiguration(
    options.customerConfiguration,
    cache,
    options.hasOwnProperty("customerConfiguration"),
  );
  return o;
}

factories["SaveCustomerConfigurationResult"] = newSaveCustomerConfigurationResult;

function maybeNewSaveCustomerConfigurationResult(
  value: SaveCustomerConfigurationResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveCustomerConfigurationResult {
  if (value === undefined) {
    return isSet
      ? undefined
      : cache["SaveCustomerConfigurationResult"] || newSaveCustomerConfigurationResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveCustomerConfigurationResult(value, cache);
  }
}

function maybeNewOrNullSaveCustomerConfigurationResult(
  value: SaveCustomerConfigurationResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveCustomerConfigurationResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveCustomerConfigurationResult(value, cache);
  }
}
export interface CutOffOptions {
  __typename?: "CutOff";
  id?: CutOff["id"];
  airtableId?: CutOff["airtableId"];
  name?: CutOff["name"];
  description?: CutOff["description"];
  marketingName?: CutOff["marketingName"];
  marketingHexColor?: CutOff["marketingHexColor"];
  sortOrder?: CutOff["sortOrder"];
}

export function newCutOff(options: CutOffOptions = {}, cache: Record<string, any> = {}): CutOff {
  const o = (options.__typename ? options : cache["CutOff"] = {}) as CutOff;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CutOff";
  o.id = options.id ?? nextFactoryId("CutOff");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.marketingName = options.marketingName ?? "marketingName";
  o.marketingHexColor = options.marketingHexColor ?? "marketingHexColor";
  o.sortOrder = options.sortOrder ?? null;
  return o;
}

factories["CutOff"] = newCutOff;

function maybeNewCutOff(value: CutOffOptions | undefined, cache: Record<string, any>, isSet: boolean = false): CutOff {
  if (value === undefined) {
    return isSet ? undefined : cache["CutOff"] || newCutOff({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCutOff(value, cache);
  }
}

function maybeNewOrNullCutOff(value: CutOffOptions | undefined | null, cache: Record<string, any>): CutOff | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCutOff(value, cache);
  }
}
export interface ImportCutOffsResultOptions {
  __typename?: "ImportCutOffsResult";
  cutOffs?: Array<CutOffOptions>;
}

export function newImportCutOffsResult(
  options: ImportCutOffsResultOptions = {},
  cache: Record<string, any> = {},
): ImportCutOffsResult {
  const o = (options.__typename ? options : cache["ImportCutOffsResult"] = {}) as ImportCutOffsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportCutOffsResult";
  o.cutOffs = (options.cutOffs ?? []).map((i) => maybeNewCutOff(i, cache, options.hasOwnProperty("cutOffs")));
  return o;
}

factories["ImportCutOffsResult"] = newImportCutOffsResult;

function maybeNewImportCutOffsResult(
  value: ImportCutOffsResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportCutOffsResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportCutOffsResult"] || newImportCutOffsResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportCutOffsResult(value, cache);
  }
}

function maybeNewOrNullImportCutOffsResult(
  value: ImportCutOffsResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportCutOffsResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportCutOffsResult(value, cache);
  }
}
export interface DevelopmentOptions {
  __typename?: "Development";
  id?: Development["id"];
  airtableId?: Development["airtableId"];
  name?: Development["name"];
  market?: MarketOptions;
  properties?: Array<PropertyOptions>;
  plans?: Array<PlanOptions>;
}

export function newDevelopment(options: DevelopmentOptions = {}, cache: Record<string, any> = {}): Development {
  const o = (options.__typename ? options : cache["Development"] = {}) as Development;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Development";
  o.id = options.id ?? nextFactoryId("Development");
  o.airtableId = options.airtableId ?? nextFactoryId("Development");
  o.name = options.name ?? "name";
  o.market = maybeNewMarket(options.market, cache, options.hasOwnProperty("market"));
  o.properties = (options.properties ?? []).map((i) =>
    maybeNewProperty(i, cache, options.hasOwnProperty("properties"))
  );
  o.plans = (options.plans ?? []).map((i) => maybeNewPlan(i, cache, options.hasOwnProperty("plans")));
  return o;
}

factories["Development"] = newDevelopment;

function maybeNewDevelopment(
  value: DevelopmentOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Development {
  if (value === undefined) {
    return isSet ? undefined : cache["Development"] || newDevelopment({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newDevelopment(value, cache);
  }
}

function maybeNewOrNullDevelopment(
  value: DevelopmentOptions | undefined | null,
  cache: Record<string, any>,
): Development | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newDevelopment(value, cache);
  }
}
export interface ImportDevelopmentsResultOptions {
  __typename?: "ImportDevelopmentsResult";
  developments?: Array<DevelopmentOptions>;
}

export function newImportDevelopmentsResult(
  options: ImportDevelopmentsResultOptions = {},
  cache: Record<string, any> = {},
): ImportDevelopmentsResult {
  const o = (options.__typename ? options : cache["ImportDevelopmentsResult"] = {}) as ImportDevelopmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportDevelopmentsResult";
  o.developments = (options.developments ?? []).map((i) =>
    maybeNewDevelopment(i, cache, options.hasOwnProperty("developments"))
  );
  return o;
}

factories["ImportDevelopmentsResult"] = newImportDevelopmentsResult;

function maybeNewImportDevelopmentsResult(
  value: ImportDevelopmentsResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportDevelopmentsResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportDevelopmentsResult"] || newImportDevelopmentsResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportDevelopmentsResult(value, cache);
  }
}

function maybeNewOrNullImportDevelopmentsResult(
  value: ImportDevelopmentsResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportDevelopmentsResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportDevelopmentsResult(value, cache);
  }
}
export interface ElevationOptions {
  __typename?: "Elevation";
  id?: Elevation["id"];
  airtableId?: Elevation["airtableId"];
  blueprintOptionCode?: Elevation["blueprintOptionCode"];
  blueprintOptionId?: Elevation["blueprintOptionId"];
  name?: Elevation["name"];
  description?: Elevation["description"];
  configurations?: Array<ConfigurationOptions>;
}

export function newElevation(options: ElevationOptions = {}, cache: Record<string, any> = {}): Elevation {
  const o = (options.__typename ? options : cache["Elevation"] = {}) as Elevation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Elevation";
  o.id = options.id ?? nextFactoryId("Elevation");
  o.airtableId = options.airtableId ?? "airtableId";
  o.blueprintOptionCode = options.blueprintOptionCode ?? "blueprintOptionCode";
  o.blueprintOptionId = options.blueprintOptionId ?? "blueprintOptionId";
  o.name = options.name ?? "name";
  o.description = options.description ?? "description";
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  return o;
}

factories["Elevation"] = newElevation;

function maybeNewElevation(
  value: ElevationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Elevation {
  if (value === undefined) {
    return isSet ? undefined : cache["Elevation"] || newElevation({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newElevation(value, cache);
  }
}

function maybeNewOrNullElevation(
  value: ElevationOptions | undefined | null,
  cache: Record<string, any>,
): Elevation | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newElevation(value, cache);
  }
}
export interface ImportElevationsResultOptions {
  __typename?: "ImportElevationsResult";
  elevations?: Array<ElevationOptions>;
}

export function newImportElevationsResult(
  options: ImportElevationsResultOptions = {},
  cache: Record<string, any> = {},
): ImportElevationsResult {
  const o = (options.__typename ? options : cache["ImportElevationsResult"] = {}) as ImportElevationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportElevationsResult";
  o.elevations = (options.elevations ?? []).map((i) =>
    maybeNewElevation(i, cache, options.hasOwnProperty("elevations"))
  );
  return o;
}

factories["ImportElevationsResult"] = newImportElevationsResult;

function maybeNewImportElevationsResult(
  value: ImportElevationsResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportElevationsResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportElevationsResult"] || newImportElevationsResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportElevationsResult(value, cache);
  }
}

function maybeNewOrNullImportElevationsResult(
  value: ImportElevationsResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportElevationsResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportElevationsResult(value, cache);
  }
}
export interface LotTypeDetailOptions {
  __typename?: "LotTypeDetail";
  code?: LotTypeDetail["code"];
  name?: LotTypeDetail["name"];
}

export function newLotTypeDetail(options: LotTypeDetailOptions = {}, cache: Record<string, any> = {}): LotTypeDetail {
  const o = (options.__typename ? options : cache["LotTypeDetail"] = {}) as LotTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotTypeDetail";
  o.code = options.code ?? LotType.Boyl;
  o.name = options.name ?? "Boyl";
  return o;
}

factories["LotTypeDetail"] = newLotTypeDetail;

export interface OptionImageTypeDetailOptions {
  __typename?: "OptionImageTypeDetail";
  code?: OptionImageTypeDetail["code"];
  name?: OptionImageTypeDetail["name"];
}

export function newOptionImageTypeDetail(
  options: OptionImageTypeDetailOptions = {},
  cache: Record<string, any> = {},
): OptionImageTypeDetail {
  const o = (options.__typename ? options : cache["OptionImageTypeDetail"] = {}) as OptionImageTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionImageTypeDetail";
  o.code = options.code ?? OptionImageType.Swatch;
  o.name = options.name ?? "Swatch";
  return o;
}

factories["OptionImageTypeDetail"] = newOptionImageTypeDetail;

export interface OptionTypeDetailOptions {
  __typename?: "OptionTypeDetail";
  code?: OptionTypeDetail["code"];
  name?: OptionTypeDetail["name"];
}

export function newOptionTypeDetail(
  options: OptionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): OptionTypeDetail {
  const o = (options.__typename ? options : cache["OptionTypeDetail"] = {}) as OptionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionTypeDetail";
  o.code = options.code ?? OptionType.SingleSelect;
  o.name = options.name ?? "Single select";
  return o;
}

factories["OptionTypeDetail"] = newOptionTypeDetail;

export interface PropertyImageTypeDetailOptions {
  __typename?: "PropertyImageTypeDetail";
  code?: PropertyImageTypeDetail["code"];
  name?: PropertyImageTypeDetail["name"];
}

export function newPropertyImageTypeDetail(
  options: PropertyImageTypeDetailOptions = {},
  cache: Record<string, any> = {},
): PropertyImageTypeDetail {
  const o = (options.__typename ? options : cache["PropertyImageTypeDetail"] = {}) as PropertyImageTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PropertyImageTypeDetail";
  o.code = options.code ?? PropertyImageType.Exterior;
  o.name = options.name ?? "Exterior";
  return o;
}

factories["PropertyImageTypeDetail"] = newPropertyImageTypeDetail;

export interface UserTypeDetailOptions {
  __typename?: "UserTypeDetail";
  code?: UserTypeDetail["code"];
  name?: UserTypeDetail["name"];
}

export function newUserTypeDetail(
  options: UserTypeDetailOptions = {},
  cache: Record<string, any> = {},
): UserTypeDetail {
  const o = (options.__typename ? options : cache["UserTypeDetail"] = {}) as UserTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserTypeDetail";
  o.code = options.code ?? UserType.Anonymous;
  o.name = options.name ?? "Anonymous";
  return o;
}

factories["UserTypeDetail"] = newUserTypeDetail;

export interface GSheetOptionPricingOptions {
  __typename?: "GSheetOptionPricing";
  id?: GSheetOptionPricing["id"];
  price?: GSheetOptionPricing["price"];
}

export function newGSheetOptionPricing(
  options: GSheetOptionPricingOptions = {},
  cache: Record<string, any> = {},
): GSheetOptionPricing {
  const o = (options.__typename ? options : cache["GSheetOptionPricing"] = {}) as GSheetOptionPricing;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GSheetOptionPricing";
  o.id = options.id ?? nextFactoryId("GSheetOptionPricing");
  o.price = options.price ?? 0;
  return o;
}

factories["GSheetOptionPricing"] = newGSheetOptionPricing;

function maybeNewGSheetOptionPricing(
  value: GSheetOptionPricingOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): GSheetOptionPricing {
  if (value === undefined) {
    return isSet ? undefined : cache["GSheetOptionPricing"] || newGSheetOptionPricing({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newGSheetOptionPricing(value, cache);
  }
}

function maybeNewOrNullGSheetOptionPricing(
  value: GSheetOptionPricingOptions | undefined | null,
  cache: Record<string, any>,
): GSheetOptionPricing | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newGSheetOptionPricing(value, cache);
  }
}
export interface HelloWorldOptions {
  __typename?: "HelloWorld";
  id?: HelloWorld["id"];
  name?: HelloWorld["name"];
  description?: HelloWorld["description"];
  priceInCents?: HelloWorld["priceInCents"];
  createdAt?: HelloWorld["createdAt"];
  updatedAt?: HelloWorld["updatedAt"];
  isActive?: HelloWorld["isActive"];
}

export function newHelloWorld(options: HelloWorldOptions = {}, cache: Record<string, any> = {}): HelloWorld {
  const o = (options.__typename ? options : cache["HelloWorld"] = {}) as HelloWorld;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HelloWorld";
  o.id = options.id ?? nextFactoryId("HelloWorld");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isActive = options.isActive ?? null;
  return o;
}

factories["HelloWorld"] = newHelloWorld;

function maybeNewHelloWorld(
  value: HelloWorldOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): HelloWorld {
  if (value === undefined) {
    return isSet ? undefined : cache["HelloWorld"] || newHelloWorld({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHelloWorld(value, cache);
  }
}

function maybeNewOrNullHelloWorld(
  value: HelloWorldOptions | undefined | null,
  cache: Record<string, any>,
): HelloWorld | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHelloWorld(value, cache);
  }
}
export interface SaveHelloWorldResultOptions {
  __typename?: "SaveHelloWorldResult";
  helloWorld?: HelloWorldOptions;
}

export function newSaveHelloWorldResult(
  options: SaveHelloWorldResultOptions = {},
  cache: Record<string, any> = {},
): SaveHelloWorldResult {
  const o = (options.__typename ? options : cache["SaveHelloWorldResult"] = {}) as SaveHelloWorldResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHelloWorldResult";
  o.helloWorld = maybeNewHelloWorld(options.helloWorld, cache, options.hasOwnProperty("helloWorld"));
  return o;
}

factories["SaveHelloWorldResult"] = newSaveHelloWorldResult;

function maybeNewSaveHelloWorldResult(
  value: SaveHelloWorldResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveHelloWorldResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveHelloWorldResult"] || newSaveHelloWorldResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveHelloWorldResult(value, cache);
  }
}

function maybeNewOrNullSaveHelloWorldResult(
  value: SaveHelloWorldResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveHelloWorldResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveHelloWorldResult(value, cache);
  }
}
export interface HomeownerOptions {
  __typename?: "Homeowner";
  id?: Homeowner["id"];
  firstName?: Homeowner["firstName"];
  lastName?: Homeowner["lastName"];
  createdAt?: Homeowner["createdAt"];
  updatedAt?: Homeowner["updatedAt"];
  user?: UserOptions;
  lastActive?: Homeowner["lastActive"];
}

export function newHomeowner(options: HomeownerOptions = {}, cache: Record<string, any> = {}): Homeowner {
  const o = (options.__typename ? options : cache["Homeowner"] = {}) as Homeowner;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Homeowner";
  o.id = options.id ?? nextFactoryId("Homeowner");
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.user = maybeNewUser(options.user, cache, options.hasOwnProperty("user"));
  o.lastActive = options.lastActive ?? null;
  return o;
}

factories["Homeowner"] = newHomeowner;

function maybeNewHomeowner(
  value: HomeownerOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Homeowner {
  if (value === undefined) {
    return isSet ? undefined : cache["Homeowner"] || newHomeowner({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHomeowner(value, cache);
  }
}

function maybeNewOrNullHomeowner(
  value: HomeownerOptions | undefined | null,
  cache: Record<string, any>,
): Homeowner | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHomeowner(value, cache);
  }
}
export interface SaveHomeownerResultOptions {
  __typename?: "SaveHomeownerResult";
  homeowner?: HomeownerOptions;
}

export function newSaveHomeownerResult(
  options: SaveHomeownerResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerResult {
  const o = (options.__typename ? options : cache["SaveHomeownerResult"] = {}) as SaveHomeownerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerResult";
  o.homeowner = maybeNewHomeowner(options.homeowner, cache, options.hasOwnProperty("homeowner"));
  return o;
}

factories["SaveHomeownerResult"] = newSaveHomeownerResult;

function maybeNewSaveHomeownerResult(
  value: SaveHomeownerResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveHomeownerResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveHomeownerResult"] || newSaveHomeownerResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveHomeownerResult(value, cache);
  }
}

function maybeNewOrNullSaveHomeownerResult(
  value: SaveHomeownerResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveHomeownerResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveHomeownerResult(value, cache);
  }
}
export interface InternalUserOptions {
  __typename?: "InternalUser";
  id?: InternalUser["id"];
  name?: InternalUser["name"];
  avatarUrl?: InternalUser["avatarUrl"];
  createdAt?: InternalUser["createdAt"];
  updatedAt?: InternalUser["updatedAt"];
  user?: UserOptions;
}

export function newInternalUser(options: InternalUserOptions = {}, cache: Record<string, any> = {}): InternalUser {
  const o = (options.__typename ? options : cache["InternalUser"] = {}) as InternalUser;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InternalUser";
  o.id = options.id ?? nextFactoryId("InternalUser");
  o.name = options.name ?? "name";
  o.avatarUrl = options.avatarUrl ?? "avatarUrl";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.user = maybeNewUser(options.user, cache, options.hasOwnProperty("user"));
  return o;
}

factories["InternalUser"] = newInternalUser;

function maybeNewInternalUser(
  value: InternalUserOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): InternalUser {
  if (value === undefined) {
    return isSet ? undefined : cache["InternalUser"] || newInternalUser({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newInternalUser(value, cache);
  }
}

function maybeNewOrNullInternalUser(
  value: InternalUserOptions | undefined | null,
  cache: Record<string, any>,
): InternalUser | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newInternalUser(value, cache);
  }
}
export interface SaveInternalUserResultOptions {
  __typename?: "SaveInternalUserResult";
  internalUser?: InternalUserOptions;
}

export function newSaveInternalUserResult(
  options: SaveInternalUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveInternalUserResult {
  const o = (options.__typename ? options : cache["SaveInternalUserResult"] = {}) as SaveInternalUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInternalUserResult";
  o.internalUser = maybeNewInternalUser(options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["SaveInternalUserResult"] = newSaveInternalUserResult;

function maybeNewSaveInternalUserResult(
  value: SaveInternalUserResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveInternalUserResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveInternalUserResult"] || newSaveInternalUserResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveInternalUserResult(value, cache);
  }
}

function maybeNewOrNullSaveInternalUserResult(
  value: SaveInternalUserResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveInternalUserResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveInternalUserResult(value, cache);
  }
}
export interface MarketOptions {
  __typename?: "Market";
  id?: Market["id"];
  airtableId?: Market["airtableId"];
  blueprintMarketId?: Market["blueprintMarketId"];
  name?: Market["name"];
  imageUrl?: Market["imageUrl"];
  developments?: Array<DevelopmentOptions>;
  propertyPriceMinInCents?: Market["propertyPriceMinInCents"];
}

export function newMarket(options: MarketOptions = {}, cache: Record<string, any> = {}): Market {
  const o = (options.__typename ? options : cache["Market"] = {}) as Market;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Market";
  o.id = options.id ?? nextFactoryId("Market");
  o.airtableId = options.airtableId ?? nextFactoryId("Market");
  o.blueprintMarketId = options.blueprintMarketId ?? "blueprintMarketId";
  o.name = options.name ?? "name";
  o.imageUrl = options.imageUrl ?? "imageUrl";
  o.developments = (options.developments ?? []).map((i) =>
    maybeNewDevelopment(i, cache, options.hasOwnProperty("developments"))
  );
  o.propertyPriceMinInCents = options.propertyPriceMinInCents ?? null;
  return o;
}

factories["Market"] = newMarket;

function maybeNewMarket(value: MarketOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Market {
  if (value === undefined) {
    return isSet ? undefined : cache["Market"] || newMarket({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newMarket(value, cache);
  }
}

function maybeNewOrNullMarket(value: MarketOptions | undefined | null, cache: Record<string, any>): Market | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newMarket(value, cache);
  }
}
export interface ImportMarketsResultOptions {
  __typename?: "ImportMarketsResult";
  markets?: Array<MarketOptions>;
}

export function newImportMarketsResult(
  options: ImportMarketsResultOptions = {},
  cache: Record<string, any> = {},
): ImportMarketsResult {
  const o = (options.__typename ? options : cache["ImportMarketsResult"] = {}) as ImportMarketsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportMarketsResult";
  o.markets = (options.markets ?? []).map((i) => maybeNewMarket(i, cache, options.hasOwnProperty("markets")));
  return o;
}

factories["ImportMarketsResult"] = newImportMarketsResult;

function maybeNewImportMarketsResult(
  value: ImportMarketsResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportMarketsResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportMarketsResult"] || newImportMarketsResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportMarketsResult(value, cache);
  }
}

function maybeNewOrNullImportMarketsResult(
  value: ImportMarketsResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportMarketsResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportMarketsResult(value, cache);
  }
}
export interface OptionOptions {
  __typename?: "Option";
  id?: Option["id"];
  name?: Option["name"];
  description?: Option["description"];
  priceInCents?: Option["priceInCents"];
  optionCode?: Option["optionCode"];
  sortOrder?: Option["sortOrder"];
  bedrooms?: Option["bedrooms"];
  fullBathrooms?: Option["fullBathrooms"];
  halfBathrooms?: Option["halfBathrooms"];
  garageAttached?: Option["garageAttached"];
  garagePort?: Option["garagePort"];
  garageDetached?: Option["garageDetached"];
  sqft?: Option["sqft"];
  parentOption?: OptionOptions | null;
  options?: Array<OptionOptions>;
  images?: Array<OptionImageOptions>;
  planOptionType?: PlanOptionTypeOptions;
  included?: Option["included"];
}

export function newOption(options: OptionOptions = {}, cache: Record<string, any> = {}): Option {
  const o = (options.__typename ? options : cache["Option"] = {}) as Option;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Option";
  o.id = options.id ?? nextFactoryId("Option");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.priceInCents = options.priceInCents ?? 0;
  o.optionCode = options.optionCode ?? "optionCode";
  o.sortOrder = options.sortOrder ?? null;
  o.bedrooms = options.bedrooms ?? 0;
  o.fullBathrooms = options.fullBathrooms ?? 0;
  o.halfBathrooms = options.halfBathrooms ?? 0;
  o.garageAttached = options.garageAttached ?? 0;
  o.garagePort = options.garagePort ?? 0;
  o.garageDetached = options.garageDetached ?? 0;
  o.sqft = options.sqft ?? 0;
  o.parentOption = maybeNewOrNullOption(options.parentOption, cache);
  o.options = (options.options ?? []).map((i) => maybeNewOption(i, cache, options.hasOwnProperty("options")));
  o.images = (options.images ?? []).map((i) => maybeNewOptionImage(i, cache, options.hasOwnProperty("images")));
  o.planOptionType = maybeNewPlanOptionType(options.planOptionType, cache, options.hasOwnProperty("planOptionType"));
  o.included = options.included ?? false;
  return o;
}

factories["Option"] = newOption;

function maybeNewOption(value: OptionOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Option {
  if (value === undefined) {
    return isSet ? undefined : cache["Option"] || newOption({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOption(value, cache);
  }
}

function maybeNewOrNullOption(value: OptionOptions | undefined | null, cache: Record<string, any>): Option | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOption(value, cache);
  }
}
export interface ImportOptionsResultOptions {
  __typename?: "ImportOptionsResult";
  options?: Array<OptionOptions>;
}

export function newImportOptionsResult(
  options: ImportOptionsResultOptions = {},
  cache: Record<string, any> = {},
): ImportOptionsResult {
  const o = (options.__typename ? options : cache["ImportOptionsResult"] = {}) as ImportOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportOptionsResult";
  o.options = (options.options ?? []).map((i) => maybeNewOption(i, cache, options.hasOwnProperty("options")));
  return o;
}

factories["ImportOptionsResult"] = newImportOptionsResult;

function maybeNewImportOptionsResult(
  value: ImportOptionsResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportOptionsResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportOptionsResult"] || newImportOptionsResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportOptionsResult(value, cache);
  }
}

function maybeNewOrNullImportOptionsResult(
  value: ImportOptionsResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportOptionsResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportOptionsResult(value, cache);
  }
}
export interface OptionImageOptions {
  __typename?: "OptionImage";
  id?: OptionImage["id"];
  name?: OptionImage["name"];
  description?: OptionImage["description"];
  imageUrl?: OptionImage["imageUrl"];
  option?: OptionOptions;
  type?: OptionImageTypeDetailOptions | OptionImageType;
}

export function newOptionImage(options: OptionImageOptions = {}, cache: Record<string, any> = {}): OptionImage {
  const o = (options.__typename ? options : cache["OptionImage"] = {}) as OptionImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionImage";
  o.id = options.id ?? nextFactoryId("OptionImage");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.imageUrl = options.imageUrl ?? "imageUrl";
  o.option = maybeNewOption(options.option, cache, options.hasOwnProperty("option"));
  o.type = enumOrDetailOfOptionImageType(options.type);
  return o;
}

factories["OptionImage"] = newOptionImage;

function maybeNewOptionImage(
  value: OptionImageOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): OptionImage {
  if (value === undefined) {
    return isSet ? undefined : cache["OptionImage"] || newOptionImage({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOptionImage(value, cache);
  }
}

function maybeNewOrNullOptionImage(
  value: OptionImageOptions | undefined | null,
  cache: Record<string, any>,
): OptionImage | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOptionImage(value, cache);
  }
}
export interface PlanOptions {
  __typename?: "Plan";
  id?: Plan["id"];
  airtableId?: Plan["airtableId"];
  name?: Plan["name"];
  blueprintLegacyReadyPlanCode?: Plan["blueprintLegacyReadyPlanCode"];
  blueprintReadyPlanCode?: Plan["blueprintReadyPlanCode"];
  blueprintReadyPlanId?: Plan["blueprintReadyPlanId"];
  description?: Plan["description"];
  development?: DevelopmentOptions;
  features?: Array<PlanFeatureOptions>;
  locations?: Array<PlanLocationOptions>;
  elevations?: Array<ElevationOptions>;
  specLevels?: Array<SpecLevelOptions>;
  customerConfigurations?: Array<CustomerConfigurationOptions>;
  baseConfiguration?: BaseConfigurationOptions | null;
  optionConflicts?: Array<PlanOptionConflictOptions>;
  minBedrooms?: Plan["minBedrooms"];
  maxBedrooms?: Plan["maxBedrooms"];
  minFullBathrooms?: Plan["minFullBathrooms"];
  maxFullBathrooms?: Plan["maxFullBathrooms"];
  minHalfBathrooms?: Plan["minHalfBathrooms"];
  maxHalfBathrooms?: Plan["maxHalfBathrooms"];
  minGarageAttached?: Plan["minGarageAttached"];
  maxGarageAttached?: Plan["maxGarageAttached"];
  minGaragePort?: Plan["minGaragePort"];
  maxGaragePort?: Plan["maxGaragePort"];
  minGarageDetached?: Plan["minGarageDetached"];
  maxGarageDetached?: Plan["maxGarageDetached"];
  minSqft?: Plan["minSqft"];
  maxSqft?: Plan["maxSqft"];
  priceInCents?: Plan["priceInCents"];
  floorPlans?: Array<PlanFloorPlanOptions>;
  optionTypes?: Array<PlanOptionTypeOptions>;
  expirationDays?: Plan["expirationDays"];
  tourUrl?: Plan["tourUrl"];
}

export function newPlan(options: PlanOptions = {}, cache: Record<string, any> = {}): Plan {
  const o = (options.__typename ? options : cache["Plan"] = {}) as Plan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Plan";
  o.id = options.id ?? nextFactoryId("Plan");
  o.airtableId = options.airtableId ?? nextFactoryId("Plan");
  o.name = options.name ?? "name";
  o.blueprintLegacyReadyPlanCode = options.blueprintLegacyReadyPlanCode ?? "blueprintLegacyReadyPlanCode";
  o.blueprintReadyPlanCode = options.blueprintReadyPlanCode ?? "blueprintReadyPlanCode";
  o.blueprintReadyPlanId = options.blueprintReadyPlanId ?? "blueprintReadyPlanId";
  o.description = options.description ?? null;
  o.development = maybeNewDevelopment(options.development, cache, options.hasOwnProperty("development"));
  o.features = (options.features ?? []).map((i) => maybeNewPlanFeature(i, cache, options.hasOwnProperty("features")));
  o.locations = (options.locations ?? []).map((i) =>
    maybeNewPlanLocation(i, cache, options.hasOwnProperty("locations"))
  );
  o.elevations = (options.elevations ?? []).map((i) =>
    maybeNewElevation(i, cache, options.hasOwnProperty("elevations"))
  );
  o.specLevels = (options.specLevels ?? []).map((i) =>
    maybeNewSpecLevel(i, cache, options.hasOwnProperty("specLevels"))
  );
  o.customerConfigurations = (options.customerConfigurations ?? []).map((i) =>
    maybeNewCustomerConfiguration(i, cache, options.hasOwnProperty("customerConfigurations"))
  );
  o.baseConfiguration = maybeNewOrNullBaseConfiguration(options.baseConfiguration, cache);
  o.optionConflicts = (options.optionConflicts ?? []).map((i) =>
    maybeNewPlanOptionConflict(i, cache, options.hasOwnProperty("optionConflicts"))
  );
  o.minBedrooms = options.minBedrooms ?? 0;
  o.maxBedrooms = options.maxBedrooms ?? 0;
  o.minFullBathrooms = options.minFullBathrooms ?? 0;
  o.maxFullBathrooms = options.maxFullBathrooms ?? 0;
  o.minHalfBathrooms = options.minHalfBathrooms ?? 0;
  o.maxHalfBathrooms = options.maxHalfBathrooms ?? 0;
  o.minGarageAttached = options.minGarageAttached ?? 0;
  o.maxGarageAttached = options.maxGarageAttached ?? 0;
  o.minGaragePort = options.minGaragePort ?? 0;
  o.maxGaragePort = options.maxGaragePort ?? 0;
  o.minGarageDetached = options.minGarageDetached ?? 0;
  o.maxGarageDetached = options.maxGarageDetached ?? 0;
  o.minSqft = options.minSqft ?? 0;
  o.maxSqft = options.maxSqft ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.floorPlans = (options.floorPlans ?? []).map((i) =>
    maybeNewPlanFloorPlan(i, cache, options.hasOwnProperty("floorPlans"))
  );
  o.optionTypes = (options.optionTypes ?? []).map((i) =>
    maybeNewPlanOptionType(i, cache, options.hasOwnProperty("optionTypes"))
  );
  o.expirationDays = options.expirationDays ?? 0;
  o.tourUrl = options.tourUrl ?? null;
  return o;
}

factories["Plan"] = newPlan;

function maybeNewPlan(value: PlanOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Plan {
  if (value === undefined) {
    return isSet ? undefined : cache["Plan"] || newPlan({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlan(value, cache);
  }
}

function maybeNewOrNullPlan(value: PlanOptions | undefined | null, cache: Record<string, any>): Plan | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlan(value, cache);
  }
}
export interface ImportPlansResultOptions {
  __typename?: "ImportPlansResult";
  plans?: Array<PlanOptions>;
}

export function newImportPlansResult(
  options: ImportPlansResultOptions = {},
  cache: Record<string, any> = {},
): ImportPlansResult {
  const o = (options.__typename ? options : cache["ImportPlansResult"] = {}) as ImportPlansResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportPlansResult";
  o.plans = (options.plans ?? []).map((i) => maybeNewPlan(i, cache, options.hasOwnProperty("plans")));
  return o;
}

factories["ImportPlansResult"] = newImportPlansResult;

function maybeNewImportPlansResult(
  value: ImportPlansResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportPlansResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportPlansResult"] || newImportPlansResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportPlansResult(value, cache);
  }
}

function maybeNewOrNullImportPlansResult(
  value: ImportPlansResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportPlansResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportPlansResult(value, cache);
  }
}
export interface PlanFeatureOptions {
  __typename?: "PlanFeature";
  id?: PlanFeature["id"];
  airtableId?: PlanFeature["airtableId"];
  iconName?: PlanFeature["iconName"];
  content?: PlanFeature["content"];
  createdAt?: PlanFeature["createdAt"];
  updatedAt?: PlanFeature["updatedAt"];
  plan?: PlanOptions;
}

export function newPlanFeature(options: PlanFeatureOptions = {}, cache: Record<string, any> = {}): PlanFeature {
  const o = (options.__typename ? options : cache["PlanFeature"] = {}) as PlanFeature;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanFeature";
  o.id = options.id ?? nextFactoryId("PlanFeature");
  o.airtableId = options.airtableId ?? "airtableId";
  o.iconName = options.iconName ?? "iconName";
  o.content = options.content ?? "content";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  return o;
}

factories["PlanFeature"] = newPlanFeature;

function maybeNewPlanFeature(
  value: PlanFeatureOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PlanFeature {
  if (value === undefined) {
    return isSet ? undefined : cache["PlanFeature"] || newPlanFeature({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanFeature(value, cache);
  }
}

function maybeNewOrNullPlanFeature(
  value: PlanFeatureOptions | undefined | null,
  cache: Record<string, any>,
): PlanFeature | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanFeature(value, cache);
  }
}
export interface PlanFloorPlanOptions {
  __typename?: "PlanFloorPlan";
  id?: PlanFloorPlan["id"];
  airtableId?: PlanFloorPlan["airtableId"];
  name?: PlanFloorPlan["name"];
  imageUrl?: PlanFloorPlan["imageUrl"];
}

export function newPlanFloorPlan(options: PlanFloorPlanOptions = {}, cache: Record<string, any> = {}): PlanFloorPlan {
  const o = (options.__typename ? options : cache["PlanFloorPlan"] = {}) as PlanFloorPlan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanFloorPlan";
  o.id = options.id ?? nextFactoryId("PlanFloorPlan");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.imageUrl = options.imageUrl ?? "imageUrl";
  return o;
}

factories["PlanFloorPlan"] = newPlanFloorPlan;

function maybeNewPlanFloorPlan(
  value: PlanFloorPlanOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PlanFloorPlan {
  if (value === undefined) {
    return isSet ? undefined : cache["PlanFloorPlan"] || newPlanFloorPlan({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanFloorPlan(value, cache);
  }
}

function maybeNewOrNullPlanFloorPlan(
  value: PlanFloorPlanOptions | undefined | null,
  cache: Record<string, any>,
): PlanFloorPlan | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanFloorPlan(value, cache);
  }
}
export interface PlanLocationOptions {
  __typename?: "PlanLocation";
  id?: PlanLocation["id"];
  airtableId?: PlanLocation["airtableId"];
  name?: PlanLocation["name"];
  description?: PlanLocation["description"];
  imageUrl?: PlanLocation["imageUrl"];
  createdAt?: PlanLocation["createdAt"];
  updatedAt?: PlanLocation["updatedAt"];
  plan?: PlanOptions;
}

export function newPlanLocation(options: PlanLocationOptions = {}, cache: Record<string, any> = {}): PlanLocation {
  const o = (options.__typename ? options : cache["PlanLocation"] = {}) as PlanLocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanLocation";
  o.id = options.id ?? nextFactoryId("PlanLocation");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.description = options.description ?? "description";
  o.imageUrl = options.imageUrl ?? "imageUrl";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  return o;
}

factories["PlanLocation"] = newPlanLocation;

function maybeNewPlanLocation(
  value: PlanLocationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PlanLocation {
  if (value === undefined) {
    return isSet ? undefined : cache["PlanLocation"] || newPlanLocation({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanLocation(value, cache);
  }
}

function maybeNewOrNullPlanLocation(
  value: PlanLocationOptions | undefined | null,
  cache: Record<string, any>,
): PlanLocation | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanLocation(value, cache);
  }
}
export interface PlanOptionConflictOptions {
  __typename?: "PlanOptionConflict";
  id?: PlanOptionConflict["id"];
  optionCode?: PlanOptionConflict["optionCode"];
  conflictOptionCode?: PlanOptionConflict["conflictOptionCode"];
  reason?: PlanOptionConflict["reason"];
  plan?: PlanOptions;
}

export function newPlanOptionConflict(
  options: PlanOptionConflictOptions = {},
  cache: Record<string, any> = {},
): PlanOptionConflict {
  const o = (options.__typename ? options : cache["PlanOptionConflict"] = {}) as PlanOptionConflict;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanOptionConflict";
  o.id = options.id ?? nextFactoryId("PlanOptionConflict");
  o.optionCode = options.optionCode ?? "optionCode";
  o.conflictOptionCode = options.conflictOptionCode ?? "conflictOptionCode";
  o.reason = options.reason ?? "reason";
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  return o;
}

factories["PlanOptionConflict"] = newPlanOptionConflict;

function maybeNewPlanOptionConflict(
  value: PlanOptionConflictOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PlanOptionConflict {
  if (value === undefined) {
    return isSet ? undefined : cache["PlanOptionConflict"] || newPlanOptionConflict({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanOptionConflict(value, cache);
  }
}

function maybeNewOrNullPlanOptionConflict(
  value: PlanOptionConflictOptions | undefined | null,
  cache: Record<string, any>,
): PlanOptionConflict | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanOptionConflict(value, cache);
  }
}
export interface ImportPlanOptionConflictsResultOptions {
  __typename?: "ImportPlanOptionConflictsResult";
  planOptionConflicts?: Array<PlanOptionConflictOptions>;
}

export function newImportPlanOptionConflictsResult(
  options: ImportPlanOptionConflictsResultOptions = {},
  cache: Record<string, any> = {},
): ImportPlanOptionConflictsResult {
  const o =
    (options.__typename ? options : cache["ImportPlanOptionConflictsResult"] = {}) as ImportPlanOptionConflictsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportPlanOptionConflictsResult";
  o.planOptionConflicts = (options.planOptionConflicts ?? []).map((i) =>
    maybeNewPlanOptionConflict(i, cache, options.hasOwnProperty("planOptionConflicts"))
  );
  return o;
}

factories["ImportPlanOptionConflictsResult"] = newImportPlanOptionConflictsResult;

function maybeNewImportPlanOptionConflictsResult(
  value: ImportPlanOptionConflictsResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportPlanOptionConflictsResult {
  if (value === undefined) {
    return isSet
      ? undefined
      : cache["ImportPlanOptionConflictsResult"] || newImportPlanOptionConflictsResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportPlanOptionConflictsResult(value, cache);
  }
}

function maybeNewOrNullImportPlanOptionConflictsResult(
  value: ImportPlanOptionConflictsResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportPlanOptionConflictsResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportPlanOptionConflictsResult(value, cache);
  }
}
export interface PlanOptionTypeOptions {
  __typename?: "PlanOptionType";
  id?: PlanOptionType["id"];
  name?: PlanOptionType["name"];
  required?: PlanOptionType["required"];
  type?: OptionTypeDetailOptions | OptionType;
  options?: Array<OptionOptions>;
}

export function newPlanOptionType(
  options: PlanOptionTypeOptions = {},
  cache: Record<string, any> = {},
): PlanOptionType {
  const o = (options.__typename ? options : cache["PlanOptionType"] = {}) as PlanOptionType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanOptionType";
  o.id = options.id ?? nextFactoryId("PlanOptionType");
  o.name = options.name ?? "name";
  o.required = options.required ?? false;
  o.type = enumOrDetailOfOptionType(options.type);
  o.options = (options.options ?? []).map((i) => maybeNewOption(i, cache, options.hasOwnProperty("options")));
  return o;
}

factories["PlanOptionType"] = newPlanOptionType;

function maybeNewPlanOptionType(
  value: PlanOptionTypeOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PlanOptionType {
  if (value === undefined) {
    return isSet ? undefined : cache["PlanOptionType"] || newPlanOptionType({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanOptionType(value, cache);
  }
}

function maybeNewOrNullPlanOptionType(
  value: PlanOptionTypeOptions | undefined | null,
  cache: Record<string, any>,
): PlanOptionType | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlanOptionType(value, cache);
  }
}
export interface PropertyOptions {
  __typename?: "Property";
  id?: Property["id"];
  airtableId?: Property["airtableId"];
  blueprintProjectId?: Property["blueprintProjectId"];
  development?: DevelopmentOptions;
  customers?: Array<CustomerOptions>;
  streetAddress?: Property["streetAddress"];
  city?: Property["city"];
  state?: Property["state"];
  postalCode?: Property["postalCode"];
  latitude?: Property["latitude"];
  longitude?: Property["longitude"];
  priceInCents?: Property["priceInCents"];
  bedrooms?: Property["bedrooms"];
  bathrooms?: Property["bathrooms"];
  sqft?: Property["sqft"];
  url?: Property["url"];
  expectedDeliveryDate?: Property["expectedDeliveryDate"];
  tourUrl?: Property["tourUrl"];
  floorPlans?: Array<PropertyFloorPlanOptions>;
  configurations?: Array<ConfigurationOptions>;
  garageAttached?: Property["garageAttached"];
  garagePort?: Property["garagePort"];
  baseConfiguration?: ConfigurationOptions | null;
  canDisplay?: PotentialOperationOptions | null;
  imageGallery?: Array<ImageGalleryImageOptions>;
  mostRecentCutOff?: PropertyCutOffOptions | null;
  isCustomizable?: Property["isCustomizable"];
}

export function newProperty(options: PropertyOptions = {}, cache: Record<string, any> = {}): Property {
  const o = (options.__typename ? options : cache["Property"] = {}) as Property;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Property";
  o.id = options.id ?? nextFactoryId("Property");
  o.airtableId = options.airtableId ?? "airtableId";
  o.blueprintProjectId = options.blueprintProjectId ?? "blueprintProjectId";
  o.development = maybeNewDevelopment(options.development, cache, options.hasOwnProperty("development"));
  o.customers = (options.customers ?? []).map((i) => maybeNewCustomer(i, cache, options.hasOwnProperty("customers")));
  o.streetAddress = options.streetAddress ?? "streetAddress";
  o.city = options.city ?? "city";
  o.state = options.state ?? "state";
  o.postalCode = options.postalCode ?? "postalCode";
  o.latitude = options.latitude ?? "latitude";
  o.longitude = options.longitude ?? "longitude";
  o.priceInCents = options.priceInCents ?? 0;
  o.bedrooms = options.bedrooms ?? "bedrooms";
  o.bathrooms = options.bathrooms ?? "bathrooms";
  o.sqft = options.sqft ?? 0;
  o.url = options.url ?? null;
  o.expectedDeliveryDate = options.expectedDeliveryDate ?? null;
  o.tourUrl = options.tourUrl ?? null;
  o.floorPlans = (options.floorPlans ?? []).map((i) =>
    maybeNewPropertyFloorPlan(i, cache, options.hasOwnProperty("floorPlans"))
  );
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  o.garageAttached = options.garageAttached ?? 0;
  o.garagePort = options.garagePort ?? 0;
  o.baseConfiguration = maybeNewOrNullConfiguration(options.baseConfiguration, cache);
  o.canDisplay = maybeNewOrNullPotentialOperation(options.canDisplay, cache);
  o.imageGallery = (options.imageGallery ?? []).map((i) =>
    maybeNewImageGalleryImage(i, cache, options.hasOwnProperty("imageGallery"))
  );
  o.mostRecentCutOff = maybeNewOrNullPropertyCutOff(options.mostRecentCutOff, cache);
  o.isCustomizable = options.isCustomizable ?? false;
  return o;
}

factories["Property"] = newProperty;

function maybeNewProperty(
  value: PropertyOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Property {
  if (value === undefined) {
    return isSet ? undefined : cache["Property"] || newProperty({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newProperty(value, cache);
  }
}

function maybeNewOrNullProperty(
  value: PropertyOptions | undefined | null,
  cache: Record<string, any>,
): Property | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newProperty(value, cache);
  }
}
export interface ImportPropertiesResultOptions {
  __typename?: "ImportPropertiesResult";
  properties?: Array<PropertyOptions>;
}

export function newImportPropertiesResult(
  options: ImportPropertiesResultOptions = {},
  cache: Record<string, any> = {},
): ImportPropertiesResult {
  const o = (options.__typename ? options : cache["ImportPropertiesResult"] = {}) as ImportPropertiesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportPropertiesResult";
  o.properties = (options.properties ?? []).map((i) =>
    maybeNewProperty(i, cache, options.hasOwnProperty("properties"))
  );
  return o;
}

factories["ImportPropertiesResult"] = newImportPropertiesResult;

function maybeNewImportPropertiesResult(
  value: ImportPropertiesResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportPropertiesResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportPropertiesResult"] || newImportPropertiesResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportPropertiesResult(value, cache);
  }
}

function maybeNewOrNullImportPropertiesResult(
  value: ImportPropertiesResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportPropertiesResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportPropertiesResult(value, cache);
  }
}
export interface ImageGalleryImageOptions {
  __typename?: "ImageGalleryImage";
  id?: ImageGalleryImage["id"];
  type?: ImageGalleryImage["type"];
  imageUrl?: ImageGalleryImage["imageUrl"];
  planLocation?: PlanLocationOptions | null;
}

export function newImageGalleryImage(
  options: ImageGalleryImageOptions = {},
  cache: Record<string, any> = {},
): ImageGalleryImage {
  const o = (options.__typename ? options : cache["ImageGalleryImage"] = {}) as ImageGalleryImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImageGalleryImage";
  o.id = options.id ?? nextFactoryId("ImageGalleryImage");
  o.type = options.type ?? PropertyImageType.Exterior;
  o.imageUrl = options.imageUrl ?? "imageUrl";
  o.planLocation = maybeNewOrNullPlanLocation(options.planLocation, cache);
  return o;
}

factories["ImageGalleryImage"] = newImageGalleryImage;

function maybeNewImageGalleryImage(
  value: ImageGalleryImageOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImageGalleryImage {
  if (value === undefined) {
    return isSet ? undefined : cache["ImageGalleryImage"] || newImageGalleryImage({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImageGalleryImage(value, cache);
  }
}

function maybeNewOrNullImageGalleryImage(
  value: ImageGalleryImageOptions | undefined | null,
  cache: Record<string, any>,
): ImageGalleryImage | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImageGalleryImage(value, cache);
  }
}
export interface PropertyCutOffOptions {
  __typename?: "PropertyCutOff";
  id?: PropertyCutOff["id"];
  airtableId?: PropertyCutOff["airtableId"];
  name?: PropertyCutOff["name"];
  description?: PropertyCutOff["description"];
  date?: PropertyCutOff["date"];
  cutOff?: CutOffOptions;
}

export function newPropertyCutOff(
  options: PropertyCutOffOptions = {},
  cache: Record<string, any> = {},
): PropertyCutOff {
  const o = (options.__typename ? options : cache["PropertyCutOff"] = {}) as PropertyCutOff;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PropertyCutOff";
  o.id = options.id ?? nextFactoryId("PropertyCutOff");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.date = options.date ?? newDate();
  o.cutOff = maybeNewCutOff(options.cutOff, cache, options.hasOwnProperty("cutOff"));
  return o;
}

factories["PropertyCutOff"] = newPropertyCutOff;

function maybeNewPropertyCutOff(
  value: PropertyCutOffOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PropertyCutOff {
  if (value === undefined) {
    return isSet ? undefined : cache["PropertyCutOff"] || newPropertyCutOff({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPropertyCutOff(value, cache);
  }
}

function maybeNewOrNullPropertyCutOff(
  value: PropertyCutOffOptions | undefined | null,
  cache: Record<string, any>,
): PropertyCutOff | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPropertyCutOff(value, cache);
  }
}
export interface ImportPropertyCutOffsResultOptions {
  __typename?: "ImportPropertyCutOffsResult";
  propertyCutOffs?: Array<PropertyCutOffOptions>;
}

export function newImportPropertyCutOffsResult(
  options: ImportPropertyCutOffsResultOptions = {},
  cache: Record<string, any> = {},
): ImportPropertyCutOffsResult {
  const o = (options.__typename ? options : cache["ImportPropertyCutOffsResult"] = {}) as ImportPropertyCutOffsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportPropertyCutOffsResult";
  o.propertyCutOffs = (options.propertyCutOffs ?? []).map((i) =>
    maybeNewPropertyCutOff(i, cache, options.hasOwnProperty("propertyCutOffs"))
  );
  return o;
}

factories["ImportPropertyCutOffsResult"] = newImportPropertyCutOffsResult;

function maybeNewImportPropertyCutOffsResult(
  value: ImportPropertyCutOffsResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportPropertyCutOffsResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportPropertyCutOffsResult"] || newImportPropertyCutOffsResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportPropertyCutOffsResult(value, cache);
  }
}

function maybeNewOrNullImportPropertyCutOffsResult(
  value: ImportPropertyCutOffsResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportPropertyCutOffsResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportPropertyCutOffsResult(value, cache);
  }
}
export interface PropertyFloorPlanOptions {
  __typename?: "PropertyFloorPlan";
  id?: PropertyFloorPlan["id"];
  airtableId?: PropertyFloorPlan["airtableId"];
  name?: PropertyFloorPlan["name"];
  imageUrl?: PropertyFloorPlan["imageUrl"];
}

export function newPropertyFloorPlan(
  options: PropertyFloorPlanOptions = {},
  cache: Record<string, any> = {},
): PropertyFloorPlan {
  const o = (options.__typename ? options : cache["PropertyFloorPlan"] = {}) as PropertyFloorPlan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PropertyFloorPlan";
  o.id = options.id ?? nextFactoryId("PropertyFloorPlan");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.imageUrl = options.imageUrl ?? "imageUrl";
  return o;
}

factories["PropertyFloorPlan"] = newPropertyFloorPlan;

function maybeNewPropertyFloorPlan(
  value: PropertyFloorPlanOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PropertyFloorPlan {
  if (value === undefined) {
    return isSet ? undefined : cache["PropertyFloorPlan"] || newPropertyFloorPlan({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPropertyFloorPlan(value, cache);
  }
}

function maybeNewOrNullPropertyFloorPlan(
  value: PropertyFloorPlanOptions | undefined | null,
  cache: Record<string, any>,
): PropertyFloorPlan | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPropertyFloorPlan(value, cache);
  }
}
export interface PotentialOperationOptions {
  __typename?: "PotentialOperation";
  allowed?: PotentialOperation["allowed"];
  disabledReasons?: Array<ReasonOptions>;
}

export function newPotentialOperation(
  options: PotentialOperationOptions = {},
  cache: Record<string, any> = {},
): PotentialOperation {
  const o = (options.__typename ? options : cache["PotentialOperation"] = {}) as PotentialOperation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialOperation";
  o.allowed = options.allowed ?? false;
  o.disabledReasons = (options.disabledReasons ?? []).map((i) =>
    maybeNewReason(i, cache, options.hasOwnProperty("disabledReasons"))
  );
  return o;
}

factories["PotentialOperation"] = newPotentialOperation;

function maybeNewPotentialOperation(
  value: PotentialOperationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PotentialOperation {
  if (value === undefined) {
    return isSet ? undefined : cache["PotentialOperation"] || newPotentialOperation({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPotentialOperation(value, cache);
  }
}

function maybeNewOrNullPotentialOperation(
  value: PotentialOperationOptions | undefined | null,
  cache: Record<string, any>,
): PotentialOperation | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPotentialOperation(value, cache);
  }
}
export interface ReasonOptions {
  __typename?: "Reason";
  message?: Reason["message"];
}

export function newReason(options: ReasonOptions = {}, cache: Record<string, any> = {}): Reason {
  const o = (options.__typename ? options : cache["Reason"] = {}) as Reason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Reason";
  o.message = options.message ?? "message";
  return o;
}

factories["Reason"] = newReason;

function maybeNewReason(value: ReasonOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Reason {
  if (value === undefined) {
    return isSet ? undefined : cache["Reason"] || newReason({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newReason(value, cache);
  }
}

function maybeNewOrNullReason(value: ReasonOptions | undefined | null, cache: Record<string, any>): Reason | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newReason(value, cache);
  }
}
export interface UserErrorOptions {
  __typename?: "UserError";
  message?: UserError["message"];
}

export function newUserError(options: UserErrorOptions = {}, cache: Record<string, any> = {}): UserError {
  const o = (options.__typename ? options : cache["UserError"] = {}) as UserError;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserError";
  o.message = options.message ?? "message";
  return o;
}

factories["UserError"] = newUserError;

function maybeNewUserError(
  value: UserErrorOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): UserError {
  if (value === undefined) {
    return isSet ? undefined : cache["UserError"] || newUserError({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUserError(value, cache);
  }
}

function maybeNewOrNullUserError(
  value: UserErrorOptions | undefined | null,
  cache: Record<string, any>,
): UserError | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUserError(value, cache);
  }
}
export interface EmptyResultOptions {
  __typename?: "EmptyResult";
  emptyResult?: EmptyResult["emptyResult"];
}

export function newEmptyResult(options: EmptyResultOptions = {}, cache: Record<string, any> = {}): EmptyResult {
  const o = (options.__typename ? options : cache["EmptyResult"] = {}) as EmptyResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EmptyResult";
  o.emptyResult = options.emptyResult ?? null;
  return o;
}

factories["EmptyResult"] = newEmptyResult;

function maybeNewEmptyResult(
  value: EmptyResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): EmptyResult {
  if (value === undefined) {
    return isSet ? undefined : cache["EmptyResult"] || newEmptyResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newEmptyResult(value, cache);
  }
}

function maybeNewOrNullEmptyResult(
  value: EmptyResultOptions | undefined | null,
  cache: Record<string, any>,
): EmptyResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newEmptyResult(value, cache);
  }
}
export interface PageInfoOptions {
  __typename?: "PageInfo";
  hasNextPage?: PageInfo["hasNextPage"];
}

export function newPageInfo(options: PageInfoOptions = {}, cache: Record<string, any> = {}): PageInfo {
  const o = (options.__typename ? options : cache["PageInfo"] = {}) as PageInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PageInfo";
  o.hasNextPage = options.hasNextPage ?? false;
  return o;
}

factories["PageInfo"] = newPageInfo;

function maybeNewPageInfo(
  value: PageInfoOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PageInfo {
  if (value === undefined) {
    return isSet ? undefined : cache["PageInfo"] || newPageInfo({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPageInfo(value, cache);
  }
}

function maybeNewOrNullPageInfo(
  value: PageInfoOptions | undefined | null,
  cache: Record<string, any>,
): PageInfo | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPageInfo(value, cache);
  }
}
export interface HistoryOptions {
  __typename?: "History";
  recordedAt?: History["recordedAt"];
  avatar?: History["avatar"];
  title?: History["title"];
  subtitle?: History["subtitle"];
}

export function newHistory(options: HistoryOptions = {}, cache: Record<string, any> = {}): History {
  const o = (options.__typename ? options : cache["History"] = {}) as History;
  (cache.all ??= new Set()).add(o);
  o.__typename = "History";
  o.recordedAt = options.recordedAt ?? newDateTime();
  o.avatar = options.avatar ?? "avatar";
  o.title = options.title ?? "title";
  o.subtitle = options.subtitle ?? null;
  return o;
}

factories["History"] = newHistory;

function maybeNewHistory(
  value: HistoryOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): History {
  if (value === undefined) {
    return isSet ? undefined : cache["History"] || newHistory({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHistory(value, cache);
  }
}

function maybeNewOrNullHistory(value: HistoryOptions | undefined | null, cache: Record<string, any>): History | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHistory(value, cache);
  }
}
export interface SpecLevelOptions {
  __typename?: "SpecLevel";
  id?: SpecLevel["id"];
  airtableId?: SpecLevel["airtableId"];
  blueprintSpecLevelId?: SpecLevel["blueprintSpecLevelId"];
  name?: SpecLevel["name"];
  description?: SpecLevel["description"];
  createdAt?: SpecLevel["createdAt"];
  updatedAt?: SpecLevel["updatedAt"];
  plan?: PlanOptions;
  configurations?: Array<ConfigurationOptions>;
}

export function newSpecLevel(options: SpecLevelOptions = {}, cache: Record<string, any> = {}): SpecLevel {
  const o = (options.__typename ? options : cache["SpecLevel"] = {}) as SpecLevel;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SpecLevel";
  o.id = options.id ?? nextFactoryId("SpecLevel");
  o.airtableId = options.airtableId ?? "airtableId";
  o.blueprintSpecLevelId = options.blueprintSpecLevelId ?? "blueprintSpecLevelId";
  o.name = options.name ?? "name";
  o.description = options.description ?? "description";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  return o;
}

factories["SpecLevel"] = newSpecLevel;

function maybeNewSpecLevel(
  value: SpecLevelOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SpecLevel {
  if (value === undefined) {
    return isSet ? undefined : cache["SpecLevel"] || newSpecLevel({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSpecLevel(value, cache);
  }
}

function maybeNewOrNullSpecLevel(
  value: SpecLevelOptions | undefined | null,
  cache: Record<string, any>,
): SpecLevel | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSpecLevel(value, cache);
  }
}
export interface ImportSpecLevelResultOptions {
  __typename?: "ImportSpecLevelResult";
  specLevels?: Array<SpecLevelOptions>;
}

export function newImportSpecLevelResult(
  options: ImportSpecLevelResultOptions = {},
  cache: Record<string, any> = {},
): ImportSpecLevelResult {
  const o = (options.__typename ? options : cache["ImportSpecLevelResult"] = {}) as ImportSpecLevelResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ImportSpecLevelResult";
  o.specLevels = (options.specLevels ?? []).map((i) =>
    maybeNewSpecLevel(i, cache, options.hasOwnProperty("specLevels"))
  );
  return o;
}

factories["ImportSpecLevelResult"] = newImportSpecLevelResult;

function maybeNewImportSpecLevelResult(
  value: ImportSpecLevelResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ImportSpecLevelResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ImportSpecLevelResult"] || newImportSpecLevelResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportSpecLevelResult(value, cache);
  }
}

function maybeNewOrNullImportSpecLevelResult(
  value: ImportSpecLevelResultOptions | undefined | null,
  cache: Record<string, any>,
): ImportSpecLevelResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newImportSpecLevelResult(value, cache);
  }
}
export interface UserOptions {
  __typename?: "User";
  id?: User["id"];
  email?: User["email"];
  deactivatedAt?: User["deactivatedAt"];
  gsuiteEmailAlias?: User["gsuiteEmailAlias"];
  createdAt?: User["createdAt"];
  updatedAt?: User["updatedAt"];
  type?: UserTypeDetailOptions | UserType;
  homeowner?: HomeownerOptions | null;
  internalUser?: InternalUserOptions | null;
  isActive?: User["isActive"];
}

export function newUser(options: UserOptions = {}, cache: Record<string, any> = {}): User {
  const o = (options.__typename ? options : cache["User"] = {}) as User;
  (cache.all ??= new Set()).add(o);
  o.__typename = "User";
  o.id = options.id ?? null;
  o.email = options.email ?? "email";
  o.deactivatedAt = options.deactivatedAt ?? null;
  o.gsuiteEmailAlias = options.gsuiteEmailAlias ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfUserType(options.type);
  o.homeowner = maybeNewOrNullHomeowner(options.homeowner, cache);
  o.internalUser = maybeNewOrNullInternalUser(options.internalUser, cache);
  o.isActive = options.isActive ?? null;
  return o;
}

factories["User"] = newUser;

function maybeNewUser(value: UserOptions | undefined, cache: Record<string, any>, isSet: boolean = false): User {
  if (value === undefined) {
    return isSet ? undefined : cache["User"] || newUser({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUser(value, cache);
  }
}

function maybeNewOrNullUser(value: UserOptions | undefined | null, cache: Record<string, any>): User | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUser(value, cache);
  }
}
export interface SaveUserResultOptions {
  __typename?: "SaveUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newSaveUserResult(
  options: SaveUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserResult {
  const o = (options.__typename ? options : cache["SaveUserResult"] = {}) as SaveUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNewUserError(i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveUserResult"] = newSaveUserResult;

function maybeNewSaveUserResult(
  value: SaveUserResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveUserResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveUserResult"] || newSaveUserResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveUserResult(value, cache);
  }
}

function maybeNewOrNullSaveUserResult(
  value: SaveUserResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveUserResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveUserResult(value, cache);
  }
}
export interface DeactivateUserResultOptions {
  __typename?: "DeactivateUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newDeactivateUserResult(
  options: DeactivateUserResultOptions = {},
  cache: Record<string, any> = {},
): DeactivateUserResult {
  const o = (options.__typename ? options : cache["DeactivateUserResult"] = {}) as DeactivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeactivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNewUserError(i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DeactivateUserResult"] = newDeactivateUserResult;

function maybeNewDeactivateUserResult(
  value: DeactivateUserResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): DeactivateUserResult {
  if (value === undefined) {
    return isSet ? undefined : cache["DeactivateUserResult"] || newDeactivateUserResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newDeactivateUserResult(value, cache);
  }
}

function maybeNewOrNullDeactivateUserResult(
  value: DeactivateUserResultOptions | undefined | null,
  cache: Record<string, any>,
): DeactivateUserResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newDeactivateUserResult(value, cache);
  }
}
export interface ActivateUserResultOptions {
  __typename?: "ActivateUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newActivateUserResult(
  options: ActivateUserResultOptions = {},
  cache: Record<string, any> = {},
): ActivateUserResult {
  const o = (options.__typename ? options : cache["ActivateUserResult"] = {}) as ActivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNewUserError(i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["ActivateUserResult"] = newActivateUserResult;

function maybeNewActivateUserResult(
  value: ActivateUserResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ActivateUserResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ActivateUserResult"] || newActivateUserResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newActivateUserResult(value, cache);
  }
}

function maybeNewOrNullActivateUserResult(
  value: ActivateUserResultOptions | undefined | null,
  cache: Record<string, any>,
): ActivateUserResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newActivateUserResult(value, cache);
  }
}
export interface UwPropertyOptions {
  __typename?: "UwProperty";
  dpid?: UwProperty["dpid"];
  fullStreetAddress?: UwProperty["fullStreetAddress"];
  cityName?: UwProperty["cityName"];
  state?: UwProperty["state"];
  zipCode?: UwProperty["zipCode"];
  latitude?: UwProperty["latitude"];
  longitude?: UwProperty["longitude"];
  unitNumber?: UwProperty["unitNumber"];
  propertyTypeSimple?: UwProperty["propertyTypeSimple"];
  lotSize?: UwProperty["lotSize"];
  yearBuiltOrRenovated?: UwProperty["yearBuiltOrRenovated"];
  finishedSqft?: UwProperty["finishedSqft"];
  totalSqft?: UwProperty["totalSqft"];
  numBedrooms?: UwProperty["numBedrooms"];
  numBaths?: UwProperty["numBaths"];
  numStories?: UwProperty["numStories"];
  hasPool?: UwProperty["hasPool"];
  garageNumCars?: UwProperty["garageNumCars"];
  buildableSqft?: UwProperty["buildableSqft"];
  lotFrontageFeet?: UwProperty["lotFrontageFeet"];
  lotDepthFeet?: UwProperty["lotDepthFeet"];
  zoning?: UwProperty["zoning"];
}

export function newUwProperty(options: UwPropertyOptions = {}, cache: Record<string, any> = {}): UwProperty {
  const o = (options.__typename ? options : cache["UwProperty"] = {}) as UwProperty;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UwProperty";
  o.dpid = options.dpid ?? nextFactoryId("UwProperty");
  o.fullStreetAddress = options.fullStreetAddress ?? "fullStreetAddress";
  o.cityName = options.cityName ?? "cityName";
  o.state = options.state ?? "state";
  o.zipCode = options.zipCode ?? "zipCode";
  o.latitude = options.latitude ?? "" as any;
  o.longitude = options.longitude ?? "" as any;
  o.unitNumber = options.unitNumber ?? null;
  o.propertyTypeSimple = options.propertyTypeSimple ?? null;
  o.lotSize = options.lotSize ?? null;
  o.yearBuiltOrRenovated = options.yearBuiltOrRenovated ?? null;
  o.finishedSqft = options.finishedSqft ?? null;
  o.totalSqft = options.totalSqft ?? null;
  o.numBedrooms = options.numBedrooms ?? null;
  o.numBaths = options.numBaths ?? null;
  o.numStories = options.numStories ?? null;
  o.hasPool = options.hasPool ?? null;
  o.garageNumCars = options.garageNumCars ?? null;
  o.buildableSqft = options.buildableSqft ?? null;
  o.lotFrontageFeet = options.lotFrontageFeet ?? null;
  o.lotDepthFeet = options.lotDepthFeet ?? null;
  o.zoning = options.zoning ?? null;
  return o;
}

factories["UwProperty"] = newUwProperty;

function maybeNewUwProperty(
  value: UwPropertyOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): UwProperty {
  if (value === undefined) {
    return isSet ? undefined : cache["UwProperty"] || newUwProperty({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUwProperty(value, cache);
  }
}

function maybeNewOrNullUwProperty(
  value: UwPropertyOptions | undefined | null,
  cache: Record<string, any>,
): UwProperty | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUwProperty(value, cache);
  }
}
const enumDetailNameOfOptionImageType = { SWATCH: "Swatch", DISPLAY: "Display", MOODBOARD: "Moodboard" };

function enumOrDetailOfOptionImageType(
  enumOrDetail: OptionImageTypeDetailOptions | OptionImageType | undefined,
): OptionImageTypeDetail {
  if (enumOrDetail === undefined) {
    return newOptionImageTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "OptionImageTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfOptionImageType[enumOrDetail.code!],
      ...enumOrDetail,
    } as OptionImageTypeDetail;
  } else {
    return newOptionImageTypeDetail({
      code: enumOrDetail as OptionImageType,
      name: enumDetailNameOfOptionImageType[enumOrDetail as OptionImageType],
    });
  }
}

function enumOrDetailOrNullOfOptionImageType(
  enumOrDetail: OptionImageTypeDetailOptions | OptionImageType | undefined | null,
): OptionImageTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfOptionImageType(enumOrDetail);
}

const enumDetailNameOfOptionType = { SINGLE_SELECT: "Single select", MULTI_SELECT: "Multi select" };

function enumOrDetailOfOptionType(enumOrDetail: OptionTypeDetailOptions | OptionType | undefined): OptionTypeDetail {
  if (enumOrDetail === undefined) {
    return newOptionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "OptionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfOptionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as OptionTypeDetail;
  } else {
    return newOptionTypeDetail({
      code: enumOrDetail as OptionType,
      name: enumDetailNameOfOptionType[enumOrDetail as OptionType],
    });
  }
}

function enumOrDetailOrNullOfOptionType(
  enumOrDetail: OptionTypeDetailOptions | OptionType | undefined | null,
): OptionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfOptionType(enumOrDetail);
}

const enumDetailNameOfUserType = {
  ANONYMOUS: "Anonymous",
  SYSTEM: "System",
  INTERNAL: "Internal",
  HOMEOWNER: "Homeowner",
};

function enumOrDetailOfUserType(enumOrDetail: UserTypeDetailOptions | UserType | undefined): UserTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserTypeDetail;
  } else {
    return newUserTypeDetail({
      code: enumOrDetail as UserType,
      name: enumDetailNameOfUserType[enumOrDetail as UserType],
    });
  }
}

function enumOrDetailOrNullOfUserType(
  enumOrDetail: UserTypeDetailOptions | UserType | undefined | null,
): UserTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserType(enumOrDetail);
}

const taggedIds: Record<string, string> = {};
let nextFactoryIds: Record<string, number> = {};

export function resetFactoryIds() {
  nextFactoryIds = {};
}

function nextFactoryId(objectName: string): string {
  const nextId = nextFactoryIds[objectName] || 1;
  nextFactoryIds[objectName] = nextId + 1;
  const tag = taggedIds[objectName] ?? objectName.replace(/[a-z]/g, "").toLowerCase();
  return tag + ":" + nextId;
}

export const possibleTypes = {};

export const enumTypePolicies = {
  LotTypeDetail: { keyFields: ["code"] },
  OptionImageTypeDetail: { keyFields: ["code"] },
  OptionTypeDetail: { keyFields: ["code"] },
  PropertyImageTypeDetail: { keyFields: ["code"] },
  UserTypeDetail: { keyFields: ["code"] },
};

interface ContractedCustomerConfigurationByCodeDataOptions {
  customerConfiguration?: CustomerConfigurationOptions;
}

export function newContractedCustomerConfigurationByCodeData(data: ContractedCustomerConfigurationByCodeDataOptions) {
  return {
    __typename: "Query" as const,
    customerConfiguration: maybeNewCustomerConfiguration(data["customerConfiguration"] || undefined, {}),
  };
}

export function newContractedCustomerConfigurationByCodeResponse(
  variables: ContractedCustomerConfigurationByCodeQueryVariables,
  data: ContractedCustomerConfigurationByCodeDataOptions | Error,
): MockedResponse<ContractedCustomerConfigurationByCodeQueryVariables, ContractedCustomerConfigurationByCodeQuery> {
  return {
    request: { query: ContractedCustomerConfigurationByCodeDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newContractedCustomerConfigurationByCodeData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCustomerDataOptions {
  createCustomer?: EmptyResultOptions;
}

export function newCreateCustomerData(data: CreateCustomerDataOptions) {
  return {
    __typename: "Mutation" as const,
    createCustomer: maybeNewEmptyResult(data["createCustomer"] || undefined, {}),
  };
}

export function newCreateCustomerResponse(
  variables: CreateCustomerMutationVariables,
  data: CreateCustomerDataOptions | Error,
): MockedResponse<CreateCustomerMutationVariables, CreateCustomerMutation> {
  return {
    request: { query: CreateCustomerDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newCreateCustomerData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface CustomerConfigurationByCodeDataOptions {
  customerConfiguration?: CustomerConfigurationOptions;
}

export function newCustomerConfigurationByCodeData(data: CustomerConfigurationByCodeDataOptions) {
  return {
    __typename: "Query" as const,
    customerConfiguration: maybeNewCustomerConfiguration(data["customerConfiguration"] || undefined, {}),
  };
}

export function newCustomerConfigurationByCodeResponse(
  variables: CustomerConfigurationByCodeQueryVariables,
  data: CustomerConfigurationByCodeDataOptions | Error,
): MockedResponse<CustomerConfigurationByCodeQueryVariables, CustomerConfigurationByCodeQuery> {
  return {
    request: { query: CustomerConfigurationByCodeDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newCustomerConfigurationByCodeData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCustomerConfigurationDataOptions {
  saveCustomerConfiguration?: SaveCustomerConfigurationResultOptions;
}

export function newSaveCustomerConfigurationData(data: SaveCustomerConfigurationDataOptions) {
  return {
    __typename: "Mutation" as const,
    saveCustomerConfiguration: maybeNewSaveCustomerConfigurationResult(
      data["saveCustomerConfiguration"] || undefined,
      {},
    ),
  };
}

export function newSaveCustomerConfigurationResponse(
  variables: SaveCustomerConfigurationMutationVariables,
  data: SaveCustomerConfigurationDataOptions | Error,
): MockedResponse<SaveCustomerConfigurationMutationVariables, SaveCustomerConfigurationMutation> {
  return {
    request: { query: SaveCustomerConfigurationDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newSaveCustomerConfigurationData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveNewCustomerConfigurationDataOptions {
  saveCustomerConfiguration?: SaveCustomerConfigurationResultOptions;
}

export function newSaveNewCustomerConfigurationData(data: SaveNewCustomerConfigurationDataOptions) {
  return {
    __typename: "Mutation" as const,
    saveCustomerConfiguration: maybeNewSaveCustomerConfigurationResult(
      data["saveCustomerConfiguration"] || undefined,
      {},
    ),
  };
}

export function newSaveNewCustomerConfigurationResponse(
  variables: SaveNewCustomerConfigurationMutationVariables,
  data: SaveNewCustomerConfigurationDataOptions | Error,
): MockedResponse<SaveNewCustomerConfigurationMutationVariables, SaveNewCustomerConfigurationMutation> {
  return {
    request: { query: SaveNewCustomerConfigurationDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newSaveNewCustomerConfigurationData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateCustomerConfigurationDataOptions {
  duplicateCustomerConfiguration?: SaveCustomerConfigurationResultOptions;
}

export function newDuplicateCustomerConfigurationData(data: DuplicateCustomerConfigurationDataOptions) {
  return {
    __typename: "Mutation" as const,
    duplicateCustomerConfiguration: maybeNewSaveCustomerConfigurationResult(
      data["duplicateCustomerConfiguration"] || undefined,
      {},
    ),
  };
}

export function newDuplicateCustomerConfigurationResponse(
  variables: DuplicateCustomerConfigurationMutationVariables,
  data: DuplicateCustomerConfigurationDataOptions | Error,
): MockedResponse<DuplicateCustomerConfigurationMutationVariables, DuplicateCustomerConfigurationMutation> {
  return {
    request: { query: DuplicateCustomerConfigurationDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newDuplicateCustomerConfigurationData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToggleOptionDataOptions {
  saveCustomerConfiguration?: SaveCustomerConfigurationResultOptions;
}

export function newToggleOptionData(data: ToggleOptionDataOptions) {
  return {
    __typename: "Mutation" as const,
    saveCustomerConfiguration: maybeNewSaveCustomerConfigurationResult(
      data["saveCustomerConfiguration"] || undefined,
      {},
    ),
  };
}

export function newToggleOptionResponse(
  variables: ToggleOptionMutationVariables,
  data: ToggleOptionDataOptions | Error,
): MockedResponse<ToggleOptionMutationVariables, ToggleOptionMutation> {
  return {
    request: { query: ToggleOptionDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newToggleOptionData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface InternalConfiguratorMarketsDataOptions {
  markets?: MarketOptions[];
}

export function newInternalConfiguratorMarketsData(data: InternalConfiguratorMarketsDataOptions) {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => newMarket(d)) || [] };
}

export function newInternalConfiguratorMarketsResponse(
  data: InternalConfiguratorMarketsDataOptions | Error,
): MockedResponse<InternalConfiguratorMarketsQueryVariables, InternalConfiguratorMarketsQuery> {
  return {
    request: { query: InternalConfiguratorMarketsDocument },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newInternalConfiguratorMarketsData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface InventoryFiltersDataOptions {
  markets?: MarketOptions[];
  cutOffs?: CutOffOptions[];
}

export function newInventoryFiltersData(data: InventoryFiltersDataOptions) {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    cutOffs: data["cutOffs"]?.map((d) => newCutOff(d)) || [],
  };
}

export function newInventoryFiltersResponse(
  data: InventoryFiltersDataOptions | Error,
): MockedResponse<InventoryFiltersQueryVariables, InventoryFiltersQuery> {
  return {
    request: { query: InventoryFiltersDocument },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newInventoryFiltersData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface InventoryPropertiesDataOptions {
  properties?: PropertyOptions[];
}

export function newInventoryPropertiesData(data: InventoryPropertiesDataOptions) {
  return { __typename: "Query" as const, properties: data["properties"]?.map((d) => newProperty(d)) || [] };
}

export function newInventoryPropertiesResponse(
  variables: InventoryPropertiesQueryVariables,
  data: InventoryPropertiesDataOptions | Error,
): MockedResponse<InventoryPropertiesQueryVariables, InventoryPropertiesQuery> {
  return {
    request: { query: InventoryPropertiesDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newInventoryPropertiesData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface SummaryPrintConfigurationDataOptions {
  customerConfiguration?: CustomerConfigurationOptions;
}

export function newSummaryPrintConfigurationData(data: SummaryPrintConfigurationDataOptions) {
  return {
    __typename: "Query" as const,
    customerConfiguration: maybeNewCustomerConfiguration(data["customerConfiguration"] || undefined, {}),
  };
}

export function newSummaryPrintConfigurationResponse(
  variables: SummaryPrintConfigurationQueryVariables,
  data: SummaryPrintConfigurationDataOptions | Error,
): MockedResponse<SummaryPrintConfigurationQueryVariables, SummaryPrintConfigurationQuery> {
  return {
    request: { query: SummaryPrintConfigurationDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newSummaryPrintConfigurationData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface SummaryPropertyDataOptions {
  propertyByBlueprintId?: PropertyOptions;
}

export function newSummaryPropertyData(data: SummaryPropertyDataOptions) {
  return {
    __typename: "Query" as const,
    propertyByBlueprintId: maybeNewProperty(data["propertyByBlueprintId"] || undefined, {}),
  };
}

export function newSummaryPropertyResponse(
  variables: SummaryPropertyQueryVariables,
  data: SummaryPropertyDataOptions | Error,
): MockedResponse<SummaryPropertyQueryVariables, SummaryPropertyQuery> {
  return {
    request: { query: SummaryPropertyDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newSummaryPropertyData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface MarketPlansStepDataOptions {
  market?: MarketOptions;
}

export function newMarketPlansStepData(data: MarketPlansStepDataOptions) {
  return { __typename: "Query" as const, market: maybeNewMarket(data["market"] || undefined, {}) };
}

export function newMarketPlansStepResponse(
  variables: MarketPlansStepQueryVariables,
  data: MarketPlansStepDataOptions | Error,
): MockedResponse<MarketPlansStepQueryVariables, MarketPlansStepQuery> {
  return {
    request: { query: MarketPlansStepDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newMarketPlansStepData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface LandingMarketsDataOptions {
  markets?: MarketOptions[];
}

export function newLandingMarketsData(data: LandingMarketsDataOptions) {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => newMarket(d)) || [] };
}

export function newLandingMarketsResponse(
  data: LandingMarketsDataOptions | Error,
): MockedResponse<LandingMarketsQueryVariables, LandingMarketsQuery> {
  return {
    request: { query: LandingMarketsDocument },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newLandingMarketsData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}

  export type MockedResponse<V, Q> = {
    request: {
      query: any;
      variables?: V;
    };
    result: {
      data?: Q;
    };
    error?: Error;
    // Note this only works if using Homebound's better-apollo-mocked-provider
    requestedCount?: number;
  };

import { dateTimeTypePolicy, dateTypePolicy } from "src/utils/dates";

export const scalarTypePolicies = {
  Asset: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  BaseConfiguration: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Configuration: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CustomerConfiguration: { fields: { reservedAt: dateTimeTypePolicy, expiredAt: dateTimeTypePolicy } },
  HelloWorld: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Homeowner: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, lastActive: dateTimeTypePolicy },
  },
  InternalUser: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanFeature: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PlanLocation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Property: { fields: { expectedDeliveryDate: dateTypePolicy } },
  PropertyCutOff: { fields: { date: dateTypePolicy } },
  History: { fields: { recordedAt: dateTimeTypePolicy } },
  SpecLevel: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  User: { fields: { deactivatedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
};

import { baseOnError } from "src/utils/baseOnError";
(defaultOptions as any).onError = (e: any) => { baseOnError(e); };